export type Language = "ar" | "en";

export const translations = {
  en: {
    hotline: "Customer Service",
    phoneNumber: "(+966) 115107110",
    email: "ksasupport@nowpay.com",
    address: "EKDA8868\nKing Faisal Ibn Abdulaziz Branch - Rawabi District - Khobar 34421 - Saudi Arabia",
    contacts: "Contacts",
    home: "Home",
    faq: "FAQ",
    careers: "Careers",
    inTheNews: "In The News",
    inTheNewsDesc: "Stay updated with the latest news and media coverage about NowPay",
    contactUs: "Contact Us",
    downloadApp: "Download the App",
    heroTitle: "Improving the financial-wellness of corporate employees",
    heroDesc: "NowPay lets you access your salary anytime and repay it over time.",
    bookDemo: "Learn More",
    whatsInIt: "What's in it for you?",
    companies: "Companies",
    teams: "Teams",
    boostWellbeing: "Boost wellbeing, productivity, loyalty",
    endHassle: "End the corporate hassle",
    zeroLiability: "Enjoy zero liability.",
    plugPlay: "Plug and play. No technical integrations",
    sharia: "Full Compliance with Sharia",
    companiesBenefit1: "Improved employee happiness, productivity and corporate loyalty",
    companiesBenefits2: "Remove the hassle of handling corporate loans",
    companiesBenefits3: "Free for corporations. Zero liability. No change in employer cash flow, we front the money",
    companiesBenefits4: "Seamless integration with your current systems",
    companiesBenefits5: "In accordance with Islamic Sharia principles",
    reduceStress: "Reduce financial stress. Access your pay anytime you want. We've got you covered",
    customerSupport: "Get customer support every day of the week",
    secureTransactions: "Secure your electronic transactions",
    teamsBenefits1: "Get customer support everyday of the week",
    teamsBenefits2: "Pay your bills instantly without the need for credit/debit cards",
    cashFree: "Enjoy living the cash-free experience",
    topShoppingNetwork: "Top Shopping Network",
    buyNow: "Buy now from your favorite stores",
    nowpayEffect: "The NowPay Effect",
    companiesCount: "300+",
    companiesDesc: "companies providing our solutions to their teams",
    paymentsCount: "1.5B+",
    paymentsDesc: "of monthly payments managed by NowPay",
    peopleCount: "350K+",
    peopleDesc: "people benefiting from NowPay's financial wellbeing solutions",
    endorsements: "Endorsements",
    testimonialText:
      "NowPay was the easiest salary advance service I ever dealt with - it also guarantees complete privacy since the employee requests the money directly through the app and no third party is involved",
    testimonialName: "Viezh Robert",
    testimonialLocation: "Warsaw, Poland",
    partnerSteps: "Becoming a Partner in 5 Simple Steps",
    step1: "Sign up to NowPay",
    step2: "Ask your team to register on the NowPay App",
    step3: "Team members ask for the services at any time",
    step4: "NowPay provides the services",
    step5: "Company repays NowPay",
    downloadTitle: "Download the NowPay App",
    downloadDesc:
      "NowPay mobile app is available on the Apple and Google stores.",
    downloadCta: "Start your financial wellbeing journey. Get the app now!",
    chooseTheStore: "Choose your app store",
    backToHome: "Back to Home Page",
    getInTouch: "Get in touch",
    contactDetails: "Please leave your contact details and we will reach out to you.",
    send: "Send",
    formName: "Name",
    formJobTitle: "Job Title",
    formEmail: "Email Address",
    formPhoneNumber: "Phone Number",
    formCompanyName: "Company Name",
    companySize: "Company Size",
    formMessage: "Message",
    slackWebhookMissing: "VITE_SLACK_WEBHOOK_URL is missing in .env.local file. Make sure to restart the server after adding the variable",
    slackWebhookInvalid: "Invalid Webhook URL. Must start with https://hooks.slack.com/services/",
    slackWebhookMock: "Please replace the Mock URL with the actual Webhook URL from Slack",
    slackWebhookNotFound: "Webhook URL is invalid or has been deleted",
    slackWebhookForbidden: "Webhook is not enabled or you do not have permission",
    slackSendFailed: "Failed to send message",
    slackNetworkError: "Network error. Please check your internet connection and Webhook URL",
    slackGenericError: "An error occurred while sending",
    slackFormType: "Form Type",
    slackDate: "Date",
    slackNotSpecified: "Not specified",
    slackNewRequest: "New request from",
    slackCustomer: "Customer",
    slackRequestHeader: "New Request",
    formSubmitSuccess: "Data sent successfully!",
    formSubmitError: "An error occurred while sending. Please try again.",
    formSubmitting: "Sending...",
    ourClients: "Our Clients",
    aboutUs: "About Us",
    privacyPolicy: "Privacy Policy",
    termsConditions: "Terms & Conditions",
    allRightsReserved: " © NowPay's. All Rights Reserved. No part of this site may be reproduced without permission.",
    regulatedBy: "Regulated by the Saudi Central Bank",
    salaryAdvance: "Salary Advance",
    cancel: "Cancel",
    payBackOver: "pay back over 5 month",
    youWillPay: "you will pay",
    sarMonthly: "SAR 525 monthly",
    startingFrom: "(approximately) starting May,2022",
    sign: "Sign",
    paymentDetails: "Payment details",
    includingFees: "Including Fees",
    BenefitsSectionTitle: "How we boost your team’s financial wellbeing",
    BenefitsSectionFeatures: [
      {
        id: 1,
        title: "All-time Salary Access",
        description:
          "NowPay gives your team access to their salaries.",
        image: "salary-access.svg",
      },
      {
        id: 2,
        title: "Invest in Gold and Silver",
        description:
          "NowPay enables your team to easily and securely invest in gold and silver directly through the app.",
        image: "gold-investment.svg",
      },
      {
        id: 3,
        title: "Instant Bill Payments",
        description:
          "NowPay enables your team to pay all their bills instantly through our app without having to enter any credit or debit card details.",
        image: "bill-payments.svg",
      },
      {
        id: 4,
        title: "Shopping Installments",
        description:
          "NowPay makes it possible for your team to shop from our network of top stores.",
        image: "shopping-installments.svg",
      },
      {
        id: 5,
        title: "Money Transfers",
        description:
          "NowPay facilitates cash-free money transfers between users through the app.",
        image: "money-transfers.svg",
      },
    ],
    endorsementsData: [
      {
        name: "Hossam Nasr Askar",
        jobTitle: "Head of Hr Operations",
        description:
          "NowPay was the easiest salary advance service I ever dealt with - it also guarantees complete privacy since the employee requests the money directly through the app and no third party is involved",
      },
      {
        name: "Sarah Abaza",
        jobTitle: "HR Manager of Canal Sugar",
        description:
          "“We are glad to partner with NowPay to help enhance the financial-wellness of our employees. NowPay’s team has been diligent and focused on providing a great experience from the initial partnership conversations all the way to the actual deployment of the service. We are very happy we established such a partnership.”",
      },
      {
        name: "Noura Mohamed",
        jobTitle: "Talent acquisition manager at Americana",
        description: "“When we listened to our colleagues, we learned that this was the sort of benefit they really wanted”"
      },
      {
        name: "Yasmine Daoud",
        jobTitle: "Talent Business Partner at KraftHeinz",
        description: "“Instant Salary Advances facility by NowPay has been great for our employees, giving them the flexibility to take control of their finances, reducing stress, and enhancing their financial wellbeing”"
      },
      {
        name: "Tarek El Maghraby",
        jobTitle: "HR Manager at Mazaya",
        description: "“Partnering with NowPay has had a positive impact on our employees' retention and financial resilience”"
      },
      {
        name: "Ramy Adel Zayed",
        jobTitle: "HR & Administration Director at Beltone Financial",
        description: "“A great benefit to improve employee financial fitness and mental wellbeing”"
      },
    ],
    Awards:"Awards & Recognition",
    awardsDesc: "Proudly awarded by trusted industry leaders",
    faqTitle: "Frequently Asked Questions",
    clientCategories: [
      "All",
      "Saudi Clients",
      "Multinationals",
      "Listed",
      "Government",
      "Industrial",
      "Manufacturing & Healthcare",
      "Aviation",
      "Large Real Estate",
      "Retail",
      "Investments",
      "Other",
    ],
    aboutNowpay: 'About Nowpay',
    aboutNowpayDesc: 'NowPay is a fintech startup building a financial-wellness platform for employees in emerging markets. We enable the workforce to better manage their budgets, and we are backed by Endure and 500 Startups.',
    servicesPricing: 'Services Pricing ',
    servicesPricingDesc: 'All services offered through the NowPay application have a clearly stated price before the purchase is completed.',
    deliveryShipmentPolicy: 'Delivery / Shipment Policy',
    deliveryShipmentPolicyDesc: [
      'Nowpay offer online services where there is no delivery or shipment included.',
      'All Nowpay services are committed at the same time of the purchase so there is no waiting time.',
      'Nowpay will NOT deal or provide any services or products to any of OFAC (Office of Foreign Assets Control) sanctions countries.',
    ],
    refundPolicy: 'Cancellation & Refund Policy',
    refundPolicyDesc: [
      'Unless otherwise is specified, purchases from Nowpay are not returnable after your purchase. Once paid, the services offered by Nowpay can\'t be cancelled or replaced once the operation is done.',
      'In case of service cancellation due to technical reasons or unavailability from the service provider, the money will be refunded within 30 days.',
      'In case you have faced any problems concerning the service you purchased, we encourage you to report the issue within 14 days from the purchase date so we can investigate accordingly.',
    ],
    noRefundPolicy: 'No Refund Policy',
    noRefundPolicyDesc: [
      'Since our Mobile Application offers non-tangible, irrevocable goods we do not provide refunds after the product is purchased, which you acknowledge prior to purchasing any product in the Mobile Application. Please make sure that you\'ve carefully read service description before making a purchase.',
      'In the event that transaction error has occurred while making the payment, a refund in most cases will be issued to the same credit card you used for the original purchase.',
      'Refunds will be done only through the Original Mode of Payment.',
    ],
    refundConditions: 'Conditions Under Which Refunds Will Be Provided',
    refundConditionsDesc: [
      'The service provider has not completed the service.',
      'Technical problem occurring during the purchase.',
    ],
    privacyPolicyContent: [
      {
        id: 1,
        title: "NowPay Privacy Policy",
        description: [
          {
            type: "none",
            content:
              "We place great importance on protecting your personal data. The personal information you provide through our website/application and services is handled confidentially and in compliance with applicable data protection laws and this Privacy Policy. Below, we provide detailed information on the personal data we collect, how we use it, whom we share it with, and the privacy rights you may be entitled to.",
          },
        ],
      },
      {
        id: 2,
        title: "Personal Information NowPay Collects",
        description: [
          {
            type: "none",
            content:
              "We collect certain personal information to deliver specific services and functionalities on our website/application. The sections below outline the various data processing activities we carry out. Each section details the purpose of the processing, the types of personal data involved, and the legal basis for the processing.",
          },
        ],
      },
      {
        id: 3,
        title: "Data Collection from Website and Application Visitors",
        description: [
          {
            type: "none",
            content:
              "Like most website and application operators, NowPay collects non-personally identifying information that web browsers and servers typically make available, such as browser type, language preference, referring site, and the date and time of each visitor request. NowPay's purpose in collecting this non-personally identifying information is to better understand how visitors use its website and application. From time to time, NowPay may release aggregated non-personally identifying information, for example, by publishing reports on usage trends.",
          },
          {
            type: "none",
            content:
              "NowPay also collects potentially personally identifying information, such as Internet Protocol (IP) addresses, for logged-in users and for users who leave comments on NowPay blog posts. NowPay discloses logged-in user and commenter IP addresses only under the same circumstances in which it discloses personally identifying information, as described below.",
          },
        ],
      },
      {
        id: 4,
        title: "Gathering of Personally Identifying Information",
        description: [
          {
            type: "none",
            content:
              "Certain visitors to NowPay's website or application choose to interact with NowPay in ways that require the collection of personally identifying information. The amount and type of information collected depend on the nature of the interaction. For example, we ask visitors who sign up for the NowPay blog to provide a username and email address.",
          },
        ],
      },
      {
        id: 5,
        title: "Data Collection from iOS or Android App",
        description: [
          {
            type: "none",
            content: "iOS/Android App collects these data - it is not shared with any third party unless stated otherwise:",
          },
          { type: "bullet", content: "Location: Approximate location, Precise location" },
          { type: "bullet", content: "Personal info: Name, Email address, User IDs, Address, Phone number" },
          {
            type: "bullet",
            content:
              "Financial info: User payment info, Other financial info (Any other financial information. For example, a user's salary or debts.)",
          },
          { type: "bullet", content: "Photos and videos: Photos" },
          { type: "bullet", content: "Contacts: Contacts" },
          { type: "bullet", content: "App activity: App interactions, In-app search history, other actions" },
          { type: "bullet", content: "App info and performance: Crash logs other app performance data" },
          { type: "bullet", content: "Device or other IDs: Device ID" },
        ],
      },
      {
        id: 6,
        title: "Data Collected During Account Registration",
        description: [
          {
            type: "none",
            content:
              "The purpose of this processing activity is to create and manage user accounts on our application. During the registration process, we will collect and process the following personal data:",
          },
          { type: "bullet", content: "First Name" },
          { type: "bullet", content: "Last Name" },
          { type: "bullet", content: "GrandFather's Name" },
          { type: "bullet", content: "Family Name" },
          { type: "bullet", content: "Employee ID" },
          { type: "bullet", content: "Mobile Number" },
          { type: "bullet", content: "Email Address" },
          { type: "bullet", content: "ID or Iqama Number" },
          { type: "bullet", content: "Bank name" },
          { type: "bullet", content: "Account Holder Name" },
          { type: "bullet", content: "IBAN number" },
        ],
      },
      {
        id: 7,
        title: "Data Collected from Website Sign Up Page",
        description: [
          {
            type: "none",
            content:
              "We collect personal data from visitors to our website/application blog to enhance their user experience and deliver tailored content. The types of data collected may include:",
          },
          { type: "bullet", content: "Names" },
          { type: "bullet", content: "Job Title" },
          { type: "bullet", content: "Email addresses" },
          { type: "bullet", content: "Phone Number" },
          { type: "bullet", content: "Company Name" },
          { type: "bullet", content: "Company Size" },
          { type: "bullet", content: "Any additional information voluntarily provided through comment or message." },
        ],
      },
      {
        id: 8,
        title: "Data Collected from Job Applications",
        description: [
          {
            type: "none",
            content:
              "The purpose of this processing activity is to evaluate applications and manage the application process. During this process, we will collect and process the following personal data:",
          },
          { type: "bullet", content: "First Name" },
          { type: "bullet", content: "Last Name" },
          { type: "bullet", content: "Email Address" },
          { type: "bullet", content: "Address" },
          { type: "bullet", content: "Phone" },
          { type: "bullet", content: "CV" },
          { type: "bullet", content: "National ID" },
          { type: "bullet", content: "Date of Birth" },
        ],
      },
      {
        id: 9,
        title: "Your Rights to Access and Amend Information",
        description: [
          {
            type: "none",
            content:
              "You can access a wide range of information about your account and interactions with the Platform, allowing you to view and, in some cases, update your details.",
          },
          { type: "none", content: "Examples of accessible information on the Platform include:" },
          {
            type: "bullet",
            content: "Email Notifications: Manage your email notification of preferences and settings.",
          },
          {
            type: "bullet",
            content:
              "Personal Information: Access and update your personally identifiable information, including your name, email address, password, phone number, communication preferences, and personalized advertising settings.",
          },
        ],
      },
      {
        id: 10,
        title: "Online:",
        description: [
          {
            type: "none",
            content:
              "If you receive marketing notifications via our mobile app or Email, please update your settings in the notifications section of our Application.",
          },
          {
            type: "none",
            content:
              "In accordance with the KSA PDPL (Personal Data Protection Law), you have the following Data Subject Rights:",
          },
          { type: "numbered", content: "1. Right to be Informed" },
          { type: "numbered", content: "2. Right to access to Personal Data" },
          { type: "numbered", content: "3. Right to request access to Personal Data" },
          { type: "numbered", content: "4. Right to Rectification and Correction" },
          { type: "numbered", content: "5. Right to erasure of Personal Data" },
        ],
      },
      {
        id: 11,
        title: "Use of Cookies and Tracking Technologies",
        description: [
          {
            type: "none",
            content:
              "To enrich and improve your online experience, NowPay uses cookies and similar technologies provided by others to display personalized content, deliver relevant advertising, and store your preferences on your device.",
          },
          {
            type: "none",
            content:
              "A cookie is a string of information that a website or application stores on a visitor's device, which the visitor's browser provides to the website or application each time they return.",
          },
          {
            type: "none",
            content:
              "NowPay uses cookies to help identify and track visitors, their usage of the NowPay website or application, and their access preferences. Visitors who do not wish to have cookies placed on their devices should set their browsers to refuse cookies before using NowPay's website or application. Please note that certain features may not function properly without cookies enabled.",
          },
          {
            type: "none",
            content:
              "By continuing to use our website or application without changing your cookie settings, you acknowledge and agree to NowPay's use of cookies. For detailed information on how we use cookies and manage them, please refer to our Cookies Policy.",
          },
        ],
      },
      {
        id: 12,
        title: "E-commerce",
        description: [
          {
            type: "none",
            content:
              "Individuals and entities who engage with NowPay for the provision of its services may be required to provide certain information, including personal and financial details, as necessary to enable NowPay to assess, deliver, and manage those services. In all cases, NowPay collects such information only to the extent that it is relevant, necessary, and appropriate for the purpose of the user's interaction with NowPay.",
          },
          {
            type: "none",
            content:
              "NowPay does not disclose personally identifiable information except as described in this Privacy Policy. Users may choose not to provide certain personal information; however, doing so may limit NowPay's ability to provide specific services or fulfill related requests.",
          },
        ],
      },
      {
        id: 13,
        title: "Data Sharing",
        description: [
          {
            type: "none",
            content:
              "Customer information is a crucial aspect of our business operations. We share your information only as outlined below and exclusively with entities that adhere to practices that are at least as protective as those described in this Privacy Policy:",
          },
          {
            type: "bullet",
            content:
              "Affiliated and Non-Affiliated Businesses:",
          },
          {
            type: "dashed",
            content:
              "- To provide our services, NowPay may engage with affiliated companies and non-affiliated third-party service providers, such as technology service providers, compliance and risk management partners, marketing service providers, and payment or transaction processing partners. These parties are granted access only to the information necessary to perform their specific functions on our behalf. NowPay ensures that such third parties are contractually restricted from using personal data for any purpose other than providing services to NowPay and are required to maintain the confidentiality and security of such information. By using our services, you acknowledge and consent to the transfer, storage, use, and disclosure of your information to these parties in accordance with this Privacy Policy.",
          },
          {
            type: "dashed",
            content:
              "- NowPay ensures that such third parties are contractually restricted from using personal data for any purpose other than providing services to NowPay and are required to maintain the confidentiality and security of such information. By using our services, you acknowledge and consent to the transfer, storage, use, and disclosure of your information to these parties in accordance with this Privacy Policy.",
          },
          {
            type: "bullet",
            content:
              "Marketing and Promotional Offers:",
          },
          {
            type: "dashed",
            content:
              "- We may use your information to inform you about our services, features, updates, and offers that may be relevant to you, as well as to enhance your experience on our platform. This may include service-related communications, announcements of new or enhanced services, system updates, improvements, promotional offers, and relevant events.",
          },
          {
            type: "dashed",
            content:
              "- We may communicate with you through various channels, including email, phone calls, push notifications, web notifications, in-app messages, and other platform-related communications, in accordance with applicable laws and your communication preferences.",
          },
          {
            type: "bullet",
            content:
              "Third-Party Use:",
          },
          {
            type: "dashed",
            content:
              "- We may allow third parties to use your information, for example, by providing advertisers with data to help them target specific audiences and fulfill our commitments to advertisers, such as displaying ads to appropriate audiences.",
          },
          {
            type: "bullet",
            content: "Business Transfers:",
          },
          {
            type: "dashed",
            content:
              "- In the event of a business acquisition or transfer of assets, customer information will be among the assets transferred.",
          },
          {
            type: "bullet",
            content:
              "Protection of Our Platform and Others:",
          },
          {
            type: "dashed",
            content:
              "- We may disclose accounts and other information if we believe it is necessary to comply with legal obligations, support law enforcement investigations, or protect the rights, property, or safety of our users or others. This may involve sharing information with other companies and organizations for purposes such as fraud protection and credit risk management.",
          },
        ],
      },
      {
        id: 14,
        title: "Data Retention",
        description: [
          {
            type: "none",
            content:
              "Unless otherwise stated in this Privacy Policy, NowPay retains personal data only for as long as is necessary to fulfill the purposes for which it was collected, including the provision of services and compliance with legal, regulatory, and contractual obligations. Once the applicable retention period has expired, personal data will be securely deleted, anonymized, or otherwise disposed of, unless retention is permitted or required by applicable laws or regulations.",
          },
          {
            type: "none",
            content:
              "NowPay implements appropriate technical and organizational measures, including data protection by design and by default, to ensure that personal data is retained only for the minimum period necessary to achieve the identified purposes.",
          },
        ],
      },
      {
        id: 15,
        title: "Data Security",
        description: [
          {
            type: "none",
            content:
              "We implement comprehensive technical and organizational measures, procedures, and operations to achieve a level of information security that aligns with the risks associated with data processing. This is done in accordance with the best international standards and practices, with the goal of protecting the privacy, confidentiality, safety, integrity, and availability of personal data.",
          },
          {
            type: "none",
            content:
              "Ensuring the security of your personal data is a priority for us. We take meticulous care in securely transmitting your personal data from your computer, smartphone, or other electronic devices to our servers. Our security practices include industry-standard protections such as firewalls, Transport Layer Security (TLS), and encryption to safeguard your data's confidentiality. We have established and maintain robust technical and organizational security measures, policies, and procedures to protect your personal data from accidental loss, unauthorized access, use, alteration, and disclosure.",
          },
          {
            type: "none",
            content:
              "However, the security of your personal data also depends on your actions. It is important to keep your password confidential and not share it with anyone. While we strive to protect your data, the transmission of information over the internet is not entirely secure. We cannot guarantee the security of data transmitted to our platform, and any transmission is done at your own risk. We are not responsible for any breach of privacy settings or security measures on the platform. For your protection, please exercise caution when sharing data over the internet.",
          },
        ],
      },
      {
        id: 16,
        title: "Update/Change in our Privacy Policy",
        description: [
          {
            type: "none",
            content:
              "NowPay may update or modify this Privacy Policy from time to time, at its sole discretion. While most changes are likely to be minor, we encourage you to review this page periodically. Your continued use of NowPay's services after any changes constitutes your acceptance of the updated Privacy Policy.",
          },
          {
            type: "none",
            content:
              "All credit/debit card information and personally identifiable information are never stored, sold, shared, rented, or leased to any third parties.",
          },
          {
            type: "none",
            content:
              "NowPay's Terms & Conditions and service policies may also be updated occasionally to meet legal, regulatory, or operational requirements. Customers are encouraged to check these sections regularly. Modifications take effect immediately upon posting.",
          },
          {
            type: "none",
            content: "This Privacy Policy was last updated on 16th December, 2025",
          },
        ],
      },
      {
        id: 17,
        title: "Contact Us",
        description: [
          {
            type: "none",
            content:
              "If you have any concerns regarding your personal information on our website or Application, please contact us at:",
          },
          { type: "bullet", content: "Email: Privacy@NowPaysaudi.com" },
        ],
      },
    ],
    questions: [
      {
        id: 1,
        question: "I would like to enroll my company or a different company in NowPay.\nWhat should I do?",
        answers: ["Sign up through learn.nowpay.com/sales or email us at team@nowpay.cash"],
      },
      {
        id: 2,
        question: "Why is my 'limit low'?",
        answers: ["Your account maybe pending HR approval and will get updated once the process is complete."],
      },
      {
        id: 3,
        question: "What do the different statuses on the transactions screen mean?",
        answers: [
          {bold: "Processing:", description: "we're still processing your request."},
          {bold: "Transferring:", description: "your request is on its way."},
          {bold: "Completed:", description: "your request is complete."},
        ],
      },
      {
        id: 4,
        question: "I want to cancel a request. What should I do?",
        answers: [
          'Tap the "salary" icon in the bar at the bottom of the home page.',
          "Select the request you wish to cancel.",
          'Tap the "edit" button.',
          'Select "cancel transaction."',
          "If you can't see a cancel button, it's because the request has already been processed and is on its way.",
        ],
      },
      {
        id: 5,
        question: "How are repayments deducted?",
        answers: ["Each repayment is deducted automatically from your future monthly salaries.\nThere's no need to make any bank transfers or have sufficient funds in your account."],
      },
    ],
    termsAndConditions: 'Terms & Conditions',
    TermsConditions1: 'Introduction',
    TermsConditionsDesc1: [
      "These terms and conditions outline the rules and regulations for the use of Nowpay's website/application.",
      'Nowpay is located at: EKDA8868 King Faisal Ibn Abdulaziz Branch - Rawabi District - Khobar 34421 - Saudi Arabia.',
      "By accessing this website/application, we assume you accept these terms and conditions in full. Do not continue to use Nowpay's website/application if you do not accept all of the terms and conditions stated on this page."
    ],
    TermsConditions2: 'Definitions and Terminology',
    TermsConditionsDesc2: [
      '"Client", "You" and "Your" refer to you, the person accessing this website/application and accepting the Company’s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us" refer to our Company. "Party", "Parties", or "Us" refer to both the Client and ourselves, or either the Client or ourselves.',
      'All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner, whether by formal meetings of a fixed duration, or any other means, for the express purpose of meeting the Client\'s needs in respect of provision of the Company\'s stated services/products, in accordance with and subject to, prevailing law of Saudi Arabia. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same cookies.'
    ],
    TermsConditions3: 'Use of Cookies',
    TermsConditionsDesc3: [
      "We employ the use of cookies. By using Nowpay's website/application, you consent to the use of cookies in accordance with Nowpay’s Privacy Policy.",
      'Most of the modern day interactive web sites/application use cookies to enable us to retrieve user details for each visit. Cookies are used in some areas of our site to enable the functionality of this area and ease of use for those people visiting. Some of our affiliate/advertising partners may also use cookies License unless otherwise stated, Nowpay and/or it\'s licensors own the intellectual property rights for all material on Nowpay. All intellectual property rights are reserved. You may view and/or print pages from NowPay for your own personal use subject to restrictions set in these terms and conditions.'
    ],
    TermsConditions4: 'You Must Not',
    TermsConditionsDesc4: [
      'Republish material from Nowpay.',
      'Sell, rent, or sub-license material from Nowpay.',
      'Reproduce, duplicate, or copy material from Nowpay.',
      'Redistribute content from Nowpay (unless the content is specifically made for redistribution).'
    ],
    TermsConditions5: 'License and Intellectual Property Rights',
    TermsConditionsDesc5: [
      'Unless otherwise stated, Nowpay and/or its licensors own the intellectual property rights for all material on Nowpay. All intellectual property rights are reserved.',
      'You may view and/or print pages from Nowpay for your personal use, subject to the restrictions set out in these terms and conditions.'
    ],
    TermsConditions6: 'Hyperlinking to Our Content',
    TermsConditionsDesc6: [
      'The following organizations may link to our Web site/application without prior written approval:',
      'Government agencies.',
      'Search engines.',
      'News organizations.',
      'Online directory distributors when they list us in the directory.',
      'System-wide Accredited Businesses.',
      { bold: 'Exception:', description: 'Non-profit organizations soliciting donations, charity shopping malls, and charity fundraising groups are not permitted to hyperlink to our website/application.' }
    ],
    TermsConditions7: 'Linking Conditions',
    TermsConditionsDesc7: [
      'Organizations may link to our home page, publications, or other website/application information provided that the link:',
      'Is not misleading in any way.',
      'Does not falsely imply sponsorship, endorsement, or approval of the linking party and its products or services.',
      'Fits within the context of the linking party’s website.'
    ],
    TermsConditions8: 'Linking Requests',
    TermsConditionsDesc8: [
      'If you are interested in linking to our website/application, you must notify us by sending an e-mail to: team[at]nowpay.com.',
      'Please include:',
      'Your name and your organization name.',
      'Contact information (such as a phone number and/or e-mail address).',
      'The URL of your website.',
      'A list of the URLs from which you intend to link to our website/application.',
      'A list of the URL(s) on our website/application to which you would like to link.',
      'Please allow 2–3 weeks for a response.'
    ],
    TermsConditions9: 'Iframes',
    TermsConditionsDesc9: 'Without prior approval and express written permission, you may not create frames around our web pages or use other techniques that alter in any way the visual presentation or appearance of our website/application.',
    TermsConditions10: 'Reservation of Rights',
    TermsConditionsDesc10: [
      'We reserve the right at any time and at our sole discretion to request that you remove all links or any particular link to our website/application. You agree to immediately remove all links to our website/application upon such request.',
      'We also reserve the right to amend these terms and conditions and our linking policy at any time. By continuing to link to our website/application, you agree to be bound by and comply with these linking terms and conditions.'
    ],
    TermsConditions11: 'Removal of Links from Our Website/Application',
    TermsConditionsDesc11: [
      'If you find any link on our website/application or any linked website/application objectionable for any reason, you may contact us about this. We will consider requests to remove links but will have no obligation to do so or to respond directly to you.',
      'Whilst we endeavour to ensure that the information on this website/application is correct, we do not warrant its completeness or accuracy, nor do we commit to ensuring that the website/application remains available or that the material on it is kept up to date.'
    ],
    TermsConditions12: 'Content Liability',
    TermsConditionsDesc12: [
      'We shall have no responsibility or liability for any content appearing on your website/application. You agree to indemnify and defend us against all claims arising out of or based upon your website/application.',
      'No link(s) may appear on any page of your website/application or within any context containing content or materials that may be interpreted as libelous, obscene, or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of any third-party rights.'
    ],
    TermsConditions13: 'Disclaimer',
    TermsConditionsDesc13: [
      'To the maximum extent permitted by applicable law, we exclude all representations, warranties, and conditions relating to our website/application and the use of this website/application, including, without limitation, any warranties implied by law in respect of satisfactory quality, fitness for a particular purpose, and/or the use of reasonable care and skill.',
      'Nothing in this disclaimer will:',
      'Limit or exclude our or your liability for death or personal injury resulting from negligence.',
      'Limit or exclude our or your liability for fraud or fraudulent misrepresentation.',
      'Limit any of our or your liabilities in any way that is not permitted under applicable law.',
      'Exclude any of our or your liabilities that may not be excluded under applicable law.'
    ],
    TermsConditions14: 'Governing Law and Jurisdiction',
    TermsConditionsDesc14: 'Any dispute or claim arising out of or in connection with this website/application shall be governed and construed in accordance with the laws of the Kingdom of Saudi Arabia.\nThe Kingdom of Saudi Arabia is our country of domicile.',
    TermsConditions15: 'Age Restrictions',
    TermsConditionsDesc15: 'Minors under the age of 18 are prohibited from registering as users of this website/application and are not permitted to transact or use the website/application.',
    TermsConditions16: 'Payment Information',
    TermsConditionsDesc16: [
      'If you make a payment for our products or services on our website/application, the details you are asked to submit will be provided directly to our payment provider via a secure connection.',
      'The cardholder/service user must retain a copy of transaction records and merchant policies and rules.',
      'We accept online payments using Visa and MasterCard credit/debit cards.'
    ],
    news: [
      {
        newsDate: "January 22, 2026",
        newsTitle: "Egypt’s NowPay enters Saudi market with $20 million-backed Tas’heel partnership",
        newsDescription: "Egypt-based fintech NowPay is launching in Saudi Arabia through NowAccess, a joint venture with Tas'heel",
        newsLink: "https://www.wamda.com/2026/01/egypt-nowpay-enters-saudi-market-20m-backed-tasheel-partnership",
        newsImage: "/news/news1.webp",
        media: "Wamda",
      },
      {
        newsDate: "January 25, 2026",
        newsTitle: "NowPay Enters Saudi Market With $20M Tas'heel Partnership",
        newsDescription: "Egyptian fintech NowPay launches NowAccess in Saudi Arabia through a $20 million joint venture with Tas'heel",
        newsLink: "https://cairoscene.com/Business/NowPay-Enters-Saudi-Market-With-20M-Tas-heel-Partnership",
        newsImage: "/news/news2.webp",
        media: "Cairo Scene",
      },
      {
        newsDate: "January 23, 2026",
        newsTitle: "NowPay enters Saudi market",
        newsDescription: "Egyptian fintech firm NowPay has entered the Saudi market through the launch of NowAccess, a joint venture with Tas'heel, the consumer finance arm",
        newsLink: "https://www.islamicfinancenews.com/nowpay-enters-saudi-market.html",
        newsImage: "/news/news3.svg",
        media: "Islamic Finance News",
      },
      {
        newsDate: "January 22, 2026",
        newsTitle: "NowPay Secures $20 Million to Expand into Saudi Arabia",
        newsDescription: "The fintech will launch its payroll and financial wellness platform through a new joint venture",
        newsLink: "https://www.startupresearcher.com/news/nowpay-secures-usd20-million-to-expand-into-saudi-arabia",
        newsImage: "/news/news4.svg",
        media: "Startup Researcher",
      },
      {
        newsDate: "January 22, 2026",
        newsTitle: "Egypt-based Fintech NowPay Raises $20M to Expand Shariah Compliance Payroll...",
        newsDescription: "Instead of navigating Saudi regulation alone, NowPay is taking the faster route—launching through a $20M-backed joint venture with Tas'heel",
        newsLink: "https://arabfounders.net/en/nowpay-enters-saudi-arabia-nowaccess-tasheel-20m-jv/",
        newsImage: "/news/news5.webp",
        media: "Arab Founders",
      },
      {
        newsDate: "January 24, 2026",
        newsTitle: "Egyptian Fintech NowPay Raises $20M to Take Its Payroll and Earned Wage Access...",
        newsDescription: "NowPay continues its regional expansion as it enters the Saudi market through a joint venture with Tas'heel",
        newsLink: "https://techbuild.africa/egyptian-fintech-nowpay-20m-payroll-earned-wage/",
        newsImage: "/news/news6.svg",
        media: "TechBuild Africa",
      },
      {
        newsDate: "June 19, 2025",
        newsTitle: "Tasheel and NowPay launch 'Now Access' to digitize wage processing in Saudi Arabia",
        newsDescription: "Tasheel and NowPay announce the launch of Now Access to digitize wage processing in Saudi Arabia",
        newsLink: "https://wasssl.com/tasheel-and-nowpay-launch-now-access-to-digitize-wage-processing-in-saudi-arabia/",
        newsImage: "/news/news7.webp",
        media: "Wasssl",
      },
      {
        newsDate: "January 22, 2026",
        newsTitle: "Egypt's NowPay Lands $20m to Launch Saudi Joint Venture",
        newsDescription: "Egypt's NowPay secures $20 million to launch its joint venture in Saudi Arabia",
        newsLink: "https://launchbaseafrica.com/2026/01/22/egypts-nowpay-lands-20m-to-launch-saudi-joint-venture/",
        newsImage: "/news/news8.svg",
        media: "LaunchBase Africa",
      }
    ],
    readArticle: "Read Article",
    articleTitle: "10 Financial Wellness Benefits That Retain Top Saudi Talent in 2025",
    articalContent: [
      {
        id: 1,
        title: "Why Financial Wellness Matters in Saudi Arabia",
        description: [
          {
            type: "none",
            content:
              "Financial stress is one of the leading causes of workplace anxiety globally, and Saudi Arabia is no exception. With the Kingdom's rapidly evolving economy under Vision 2030, employees face unique financial challenges and opportunities. Here are ten essential tips to help you achieve financial wellness in 2025.",
          },
        ],
      },
      {
        id: 2,
        title: "1. Master the 50/30/20 Budget Rule",
        description: [
          {
            type: "none",
            content:
              "One of the most effective budgeting strategies is the 50/30/20 rule:",
          },
          { type: "bullet", content: "50% for Needs: Housing, utilities, transportation, groceries, and essential bills" },
          { type: "bullet", content: "30% for Wants: Entertainment, dining out, shopping, and lifestyle choices" },
          { type: "bullet", content: "20% for Savings: Emergency fund, investments, and future goals" },
          {
            type: "none",
            content:
              "For Saudi employees earning an average salary, this might look like:",
          },
          { type: "bullet", content: "SAR 7,500 for essential expenses" },
          { type: "bullet", content: "SAR 4,500 for lifestyle spending" },
          { type: "bullet", content: "SAR 3,000 for savings and investments" },
        ],
      },
      {
        id: 3,
        title: "2. Build an Emergency Fund",
        description: [
          {
            type: "none",
            content:
              "Financial experts recommend having 3-6 months of expenses saved in an easily accessible account. In the Saudi context, aim for at least SAR 30,000 as a starting emergency fund.",
          },
          { type: "bold", content: "How to Build Your Emergency Fund:" },
          { type: "bullet", content: "Start with SAR 500 per month" },
          { type: "bullet", content: "Automate transfers to a separate savings account" },
          { type: "bullet", content: "Increase contributions when you receive bonuses" },
          { type: "bullet", content: "Consider high-yield savings accounts at Saudi banks" },
        ],
      },
      {
        id: 4,
        title: "3. Understand Your End-of-Service Benefits (EOSB)",
        description: [
          {
            type: "none",
            content:
              "Saudi labor law entitles employees to End-of-Service Benefits. Understanding how this is calculated can help you plan better:",
          },
          { type: "bullet", content: "2+ Years: Half-month salary per year for the first 5 years" },
          { type: "bullet", content: "5+ Years: Full-month salary per year for subsequent years" },
          { type: "bullet", content: "Use this as part of your long-term financial planning" },
        ],
      },
      {
        id: 5,
        title: "4. Plan for Seasonal Expenses",
        description: [
          {
            type: "none",
            content:
              "Saudi Arabia has unique seasonal spending patterns:",
          },
          { type: "bold", content: "Ramadan Expenses" },
          { type: "bullet", content: "Increased food costs for iftar and suhoor" },
          { type: "bullet", content: "Charitable giving (Zakat and Sadaqah)" },
          { type: "bullet", content: "Family gatherings and hospitality" },
          { type: "bold", content: "Eid Celebrations" },
          { type: "bullet", content: "New clothes for family members" },
          { type: "bullet", content: "Gifts and Eidiyah for children" },
          { type: "bullet", content: "Travel for family visits" },
          {
            type: "none",
            content:
              "Pro Tip: Start saving for these expenses 3-4 months in advance by setting aside SAR 1,000-2,000 monthly.",
          },
        ],
      },
      {
        id: 6,
        title: "5. Leverage Employer Benefits",
        description: [
          { type: "none", content: "Many Saudi employers offer benefits beyond salary:" },
          { type: "bullet", content: "Housing allowance: Often 25% of base salary" },
          { type: "bullet", content: "Transportation allowance: SAR 1,000-3,000 monthly" },
          { type: "bullet", content: "Medical insurance: Family coverage" },
          { type: "bullet", content: "Annual tickets: For expatriate employees" },
          { type: "bullet", content: "Financial wellness programs: Like Earned Wage Access" },
          {
            type: "none",
            content:
              "Make sure you're utilizing all available benefits to maximize your total compensation.",
          },
        ],
      },
      {
        id: 7,
        title: "6. Avoid High-Interest Debt",
        description: [
          {
            type: "none",
            content:
              "Credit card debt in Saudi Arabia can carry interest rates of 20-30% APR. To avoid the debt trap:",
          },
          { type: "bullet", content: "Pay credit card balances in full each month" },
          { type: "bullet", content: "Use debit cards for everyday purchases" },
          { type: "bullet", content: "Consider Sharia-compliant alternatives for large purchases" },
          { type: "bullet", content: "If you need emergency funds, explore Earned Wage Access options" },
        ],
      },
      {
        id: 8,
        title: "7. Invest in Your Future",
        description: [
          { type: "none", content: "Saudi Arabia offers several investment options:" },
          { type: "bold", content: "Stock Market (Tadawul)" },
          { type: "bullet", content: "Open a trading account with licensed brokers" },
          { type: "bullet", content: "Start with blue-chip Saudi companies" },
          { type: "bullet", content: "Consider index funds for diversification" },
          { type: "bold", content: "Real Estate" },
          { type: "bullet", content: "Government programs like Sakani for first-time buyers" },
          { type: "bullet", content: "Real estate investment trusts (REITs)" },
          { type: "bold", content: "Retirement Planning" },
          { type: "bullet", content: "Contribute to voluntary pension schemes" },
          { type: "bullet", content: "Consider private retirement savings plans" },
        ],
      },
      {
        id: 9,
        title: "8. Track Your Spending",
        description: [
          { type: "none", content: "Use budgeting apps to monitor where your money goes:" },
          { type: "bullet", content: "Categorize expenses automatically" },
          { type: "bullet", content: "Set spending limits for each category" },
          { type: "bullet", content: "Review weekly to stay on track" },
          { type: "bullet", content: "Identify areas for potential savings" },
        ],
      },
      {
        id: 10,
        title: "9. Negotiate Your Salary Wisely",
        description: [
          { type: "none", content: "The Saudi job market is competitive. To maximize your earning potential:" },
          { type: "bullet", content: "Research market rates for your position" },
          { type: "bullet", content: "Document your achievements and impact" },
          { type: "bullet", content: "Time negotiations during performance reviews" },
          { type: "bullet", content: "Consider the total package, not just base salary" },
        ],
      },
      {
        id: 11,
        title: "10. Seek Financial Education",
        description: [
          { type: "none", content: "Continuous learning about personal finance can transform your financial future:" },
          { type: "bullet", content: "Follow SAMA's financial literacy initiatives" },
          { type: "bullet", content: "Attend financial wellness workshops" },
          { type: "bullet", content: "Read Arabic and English financial resources" },
          { type: "bullet", content: "Join online communities focused on personal finance in Saudi Arabia" },
        ],
      },
      {
        id: 12,
        title: "Taking Control of Your Financial Future",
        description: [
          {
            type: "none",
            content:
              "Financial wellness is a journey, not a destination. By implementing these strategies consistently, you can reduce financial stress, build wealth, and enjoy greater peace of mind. Remember, small steps taken today lead to significant financial improvements over time.",
          },
          {
            type: "none",
            content:
              "Start with one or two tips that resonate most with your current situation, master them, and gradually incorporate more strategies into your financial routine.",
          },
        ],
      }
    ],
    articleCopyright: "© 2026 NowPay. All rights reserved.",
    articalModalTitle: "Continue Reading",
    articalModalDescription: "Enter your details to access the full article",
    articalButton: "Unlock Article",
    arabic: "Arabic",
    english: "English",
    formConsent: "I have read and understood the Service Consent Form, and I consent to the collection, use, and disclosure of my personal data as described in it.",
  },
  ar: {
    hotline: "خدمة العملاء",
    phoneNumber: "(+966) 115107110",
    email: "support@nowpay.com",
    address: "EKDA8868\nالملك فيصل ابن عبدالعزيز الفرعي - حي الروابي - الخبر 34421 - المملكة العربية السعودية",
    contacts: "تواصل معنا",
    home: "الرئيسية",
    faq: "اسئلة مكررة",
    careers: "الوظائف",
    inTheNews: "في الأخبار",
    inTheNewsDesc: "تابع آخر الأخبار والتغطيات الصحفية عن ناوباي في وسائل الإعلام",
    contactUs: "تواصل معنا",
    downloadApp: " قم بتنزيل التطبيق",
    heroTitle: "وفّر لفريقك الأمان المالي",
    heroDesc: 'تتيح لك خدمة "ناوباي" الحصول على راتبك في أي وقت، مع إمكانية السداد بمرونة من راتبك الشهور القادمة',
    bookDemo: "تعرف على المزيد",
    whatsInIt: "ما الذي سيعود عليك؟",
    companies: "الشركات",
    teams: "فريق العمل",
    boostWellbeing: "تعزيز الرفاهية والإنتاجية والولاء",
    endHassle: "إنهاء المتاعب الإدارية",
    zeroLiability: "استمتع بعدم تحمل أي مسؤولية",
    plugPlay: "سهل الاستخدام. بدون تكاملات تقنية",
    sharia: "متوافق تماماً مع الشريعة الإسلامية",
    companiesBenefit1: "تعزيز الأمان المالي لفريقك وزيادة الإنتاجية والولاء",
    companiesBenefits2: "التخلص من متاعب القروض للشركات",
    companiesBenefits3: "استمتع بخدماتنا مجانًا وبدون أي مدفوعات مسبقة، فنحن نتكفل بالنفقات مقدماً!",
    companiesBenefits4: "لا تعقيدات تقنية، كل ما عليك  هو تحميل التطبيق وتسجيل الدخول",
    companiesBenefits5: "توافق مع مبادئ الشريعة الإسلامية",
    reduceStress: "تخفيف الضغوط المالية. نوفر لكم إمكانية الوصول إلى رواتبكم متى شئتم، حتى تتمكنوا من تلبية احتياجاتكم المالية في أي وقت",
    customerSupport: "خدمة العملاء على مدار الأسبوع",
    secureTransactions: "معاملات إلكترونية سلسة وآمنة",
    teamsBenefits1: "قم بإدارة وتتبع مدخراتك ونفقاتك، واحصل على توصيات مالية قيمة",
    teamsBenefits2: "سداد الفواتير على الفور دون الحاجة إلى بطاقات الائتمان/الخصم.",
    cashFree: "تجربة غير نقدية",
    topShoppingNetwork: "تسوّق من أفضل المتاجر",
    buyNow: 'احصل على مشترياتك من متاجرك المفضلة، وادفع لاحقاً على أقساط تخصم من الراتب، في مدة تصل إلى 10 أشهر.',
    nowpayEffect: "حقائق وأرقام ناوباى",
    companiesCount: "+300",
    companiesDesc: "عدد الشركات التي نقدم حلولنا لفرقهم",
    paymentsCount: "+1.5B",
    paymentsDesc: "من الدفعات الشهرية تدار بواسطة ناو باي",
    peopleCount: "+350K",
    peopleDesc: "من الأشخاص الذين يستفيدون من حلول الامان المالي التى تقدمها ناو باى",
    endorsements: "شهادات عملائنا",
    testimonialText:
      "ناو باي كانت أسهل خدمة سلفة راتب تعاملت معها على الإطلاق - كما أنها تضمن الخصوصية الكاملة حيث يطلب الموظف المال مباشرة من خلال التطبيق ولا يوجد طرف ثالث متورط",
    testimonialName: "فيزه روبرت",
    testimonialLocation: "وارسو، بولندا",
    partnerSteps: "انضم إلينا في 5 خطوات بسيطة",
    step1: "اشترك في ناوباي",
    step2: "اطلب من فريقك التسجيل في تطبيق ناوباي",
    step3:"يمكن لأعضاء فريقك طلب رواتبهم مقدماً في أي وقت",
    step4: "توفر ناوباي الأموال مقدماً",
    step5: "تقوم الشركة بخصم الدفعات المقدمة من الرواتب مستقبلاً، وتسددها لـ ناوباي",
    downloadTitle: "قم بتنزيل تطبيق ناوباي",
    downloadDesc: "تطبيق الجوال من ناوباي متاح على جوجل بلاي وآبل.",
    downloadCta: "قم بتنزيل التطبيق الآن، واستمتع بالأمان المالي!",
    chooseTheStore: "اختر متجر التطبيقات الخاص بك",
    backToHome: "العودة إلى الصفحة الرئيسية",
    getInTouch: "تواصل معنا",
    contactDetails: "يرجى ترك بيانات التواصل الخاصة بك وسنقوم بالتواصل معك.",
    send: "إرسال",
    formName: "الاسم",
    formJobTitle: "المسمى الوظيفي",
    formEmail: "البريد الإلكتروني",
    formPhoneNumber: "رقم الهاتف",
    formCompanyName: "اسم الشركة",
    companySize: "عدد موظفين الشركة",
    formMessage: "الرسالة",
    slackWebhookMissing: "VITE_SLACK_WEBHOOK_URL غير موجود في ملف .env.local. تأكد من إعادة تشغيل السيرفر بعد إضافة المتغير",
    slackWebhookInvalid: "الـ Webhook URL غير صحيح. يجب أن يبدأ بـ https://hooks.slack.com/services/",
    slackWebhookMock: "يرجى استبدال الـ Mock URL بالـ Webhook URL الحقيقي من Slack",
    slackWebhookNotFound: "الـ Webhook URL غير صحيح أو تم حذفه",
    slackWebhookForbidden: "الـ Webhook غير مفعل أو ليس لديك صلاحية",
    slackSendFailed: "فشل إرسال الرسالة",
    slackNetworkError: "خطأ في الاتصال بالشبكة. يرجى التحقق من اتصال الإنترنت والـ Webhook URL",
    slackGenericError: "حدث خطأ أثناء الإرسال",
    slackFormType: "نوع الطلب",
    slackDate: "التاريخ",
    slackNotSpecified: "غير محدد",
    slackNewRequest: "طلب جديد من",
    slackCustomer: "عميل",
    slackRequestHeader: "طلب جديد",
    formSubmitSuccess: "تم إرسال البيانات بنجاح!",
    formSubmitError: "حدث خطأ أثناء الإرسال. يرجى المحاولة مرة أخرى.",
    formSubmitting: "جاري الإرسال...",
    ourClients: "عملائنا",
    aboutUs: "معلومات عنا",
    privacyPolicy: "سياسة الخصوصية",
    termsConditions: "البنود و الظروف",
    allRightsReserved: "© ناوباي. كل الحقوق محفوظة. لا يجوز إعادة إنتاج أي جزء من هذا الموقع دون إذن.",
    regulatedBy: "مرخصة من البنك المركزي السعودي",
    salaryAdvance: "سلفة الراتب",
    cancel: "إلغاء",
    payBackOver: "السداد على 5 أشهر",
    youWillPay: "ستدفع",
    sarMonthly: "525 ريال شهرياً",
    startingFrom: "(تقريباً) بدءاً من مايو 2022",
    sign: "توقيع",
    paymentDetails: "تفاصيل الدفع",
    includingFees: "شامل الرسوم",
    BenefitsSectionTitle: "كيف نعزز الأمان المالي لفريقك",
    BenefitsSectionFeatures: [
      {
        id: 1,
        title: "حرية الحصول على الراتب في أي وقت",
        description:
          "تمنح ناوباي فريقك الحصول على رواتبهم متى احتاجوا إليها، و تقسيطها على فترة سداد مرنة.",
        image: "salary-access.svg",
      },
      {
        id: 2,
        title: "الاستثمار في الذهب والفضة",
        description:
          "يُمكّن فريقك من الاستثمار بسهولة وأمان في الذهب والفضة مباشرة عبر التطبيق.",
        image: "gold-investment.svg",
      },

      {
        id: 3,
        title: "سداد فوري للفواتير",
        description:
          "توفر ناوباي لفريقك القدرة على سداد جميع فواتيرهم على الفور من خلال تطبيقنا دون الحاجة إلى إدخال بيانات بطاقة الائتمان أو الخصم.",
        image: "bill-payments.svg",
      },
      {
        id: 4,
        title: "سداد فواتير التسوق على أقساط",
        description:
          "تتيح ناوباي لفريقك التسوق من شبكتنا التي تضم أفضل المتاجر، مع خطة سداد مرنة على أقساط تصل إلى 10 أشهر.",
        image: "shopping-installments.svg",
      },
      {
        id: 5,
        title: "تحويل الأموال بين موظفي شركتك",
        description:
          "تسهل ناوباي تحويل الأموال بين أعضاء فريقك عبر التطبيق.",
        image: "money-transfers.svg",
      },
    ],
    endorsementsData: [
      {
        name: "حسام نصر عسكر",
        jobTitle: "رئيس عمليات الموارد البشرية ",
        description :"”ناوباي هي أسهل خدمة للحصول على الرواتب مقدماً تعاملت معها على الإطلاق - كما أنها تضمن الخصوصية الكاملة للموظفين حيث أن المستخدم يطلب المبلغ مباشرةً من خلال التطبيق بسرية تامة“ "
      },
      {
        name: "سارة أباظة",
        jobTitle: "مدير الموارد البشرية",
        description:
          "”نحن سعداء بالتعاون مع ناوباي لتعزيز رفاهية الموظفين المالية. كان فريق ناوباي مجتهدًا ومركزاً على توفير تجربة رائعة من محادثات الشراكة الأولية حتى تنفيذ الخدمة الفعلي. نحن سعداء جدًا لتأسيس مثل هذه الشراكة“",
      },
      {
        name:"نورا محمد",
        jobTitle: "مدير اكتساب المواهب",
        description: "”عندما استمعنا إلى موظفينا، وجدنا أن خدمة الراتب مقدماً من أهم الخدمات التي ستشكل فارق كبير في راحتهم واستقرارهم“"
      },
      {
        name: "ياسمين داود",
        jobTitle: "شريك اكتساب المواهب",
        description: "“خدمة الراتب مقدما الفورية المقدمة من من ناوباي أثرت بشكل إيجابي كبير على موظفينا ، حيث منحتهم المرونة للسيطرة على مواردهم المالية ، والحد من التوتر ، وتحسين رفاهيتهم بشكل عام”"
      },
      {
        name: "طارق المغربي",
        jobTitle: "مدير الموارد البشرية",
        description: "“الشراكة مع ناوباي كان لها تأثير إيجابي كبير على احتفاظنا بموظفينا وتحسين استقرارهم المالي وقدرتهم على إدارة حياتهم المالية بكل راحة”"
      },
      {
        name: "رامي عادل زايد",
        jobTitle: "مدير الموارد البشرية والشؤون الإدارية",
        description: "“خدمة مفيدة جدا لتحسين الاستقرار المالي للموظفين وراحتهم النفسية”"
      },
    ],
    Awards:"الجوائز والتقديرات",
    awardsDesc: "حصلنا على تقدير أبرز الجهات الموثوقة في المجال",
    faqTitle: "الأسئلة الشائعة",
    clientCategories: [
      "الكل",
      "عملاء السعودية",
      "شركات عالمية",
      "شركات مدرجة",
      "جهات حكومية",
      "قطاع صناعي",
      "التصنيع والرعاية الصحية",
      "قطاع الطيران",
      "العقارات الكبرى",
      "قطاع التجزئة",
      "قطاع الاستثمارات",
      "أخرى",
    ],
    aboutNowpay: 'عن ناوباي',
    aboutNowpayDesc: 'ناوباي هي شركة ناشئة في مجال التكنولوجيا المالية تقوم ببناء منصة للرفاهية المالية للموظفين في الأسواق الناشئة. نُساعد القوى العاملة على إدارة ميزانياتهم بشكل أفضل، ونحن مدعومون من Endure  و 500 Startups',
    servicesPricing: 'سعر الخدمات',
    servicesPricingDesc: 'جميع الخدمات المقدمة عبر تطبيق ناوباي تحتوي على سعر واضح قبل إتمام عملية الشراء.',
    deliveryShipmentPolicy: 'سياسة التسليم / الشحن',
    deliveryShipmentPolicyDesc: [
      'تقدم ناوباي خدمات عبر الإنترنت وخدمات تسوق غير متصلة بالإنترنت',
      'يتم تسليم خدمات ناوباي في غضون حد أقصى ٤٨ ساعة. أي خدمات أخرى تتضمن طرفًا ثالثًا تعتمد على الإطار الزمني الخاص بكل طرف ثالث.',
      'لا تقدم ناوباي خدمات أو منتجات إلى أي دول خاضعة لعقوبات مكتب مراقبة الأصول الأجنبية (OFAC).'
    ],
    refundPolicy: 'سياسة الإلغاء والاسترداد',
    refundPolicyDesc: [
      'ما لم ينص على خلاف ذلك، فإن المشتريات من ناوباي غير قابلة للإعادة بعد إتمامها. بمجرد الدفع، لا يمكن إلغاء الخدمات أو استبدالها.',
      'ي حال إلغاء الخدمة بسبب مشاكل تقنية أو عدم توفرها من مزود الخدمة، سيتم إصدار استرداد مالي خلال ٣٠ يومًا.',
      'إذا واجهت أي مشكلة في خدمة تم شراؤها، يرجى الإبلاغ عن المشكلة خلال ١٤ يومًا من تاريخ الشراء حتى نتمكن من التحقيق',
    ],
    noRefundPolicy: 'سياسة عدم الاسترداد ',
    noRefundPolicyDesc: [
      'نظرًا لأن تطبيقنا يقدم سلعًا غير ملموسة ولا يمكن الرجوع فيها، لا يتم تقديم استرداد مالي بعد شراء المنتج. أنت تقر بذلك قبل إجراء أي عملية شراء. يرجى التأكد من قراءة وصف الخدمة بعناية قبل إتمام الشراء.',
      'إذا حدث خطأ في المعاملة أثناء الدفع، فسيتم في معظم الحالات إصدار استرداد لنفس بطاقة الائتمان المستخدمة في الشراء الأصلي.',
      'سيتم إصدار الاسترداد فقط عبر طريقة الدفع الأصلية.',
    ],
    refundConditions: 'الأحوال التي يتم فيها تقديم الاسترداد',
    refundConditionsDesc: [
      'لم يقُم مزود الخدمة بإكمال الخدمة.',
      'حدثت مشكلة تقنية أثناء الشراء.',
    ],
    privacyPolicyContent: [
      {
        id: 1,
        title: "سياسة خصوصية NowPay",
        description: [
          {
            type: "none",
            content:
              "نولي أهمية قصوى لحماية البيانات الشخصية. يتم التعامل مع المعلومات الشخصية التي يتم تقديمها من خلال الموقع الإلكتروني / التطبيق والخدمات الخاصة بنا بسرية تامة وخدماتنا بسرية تامة وفقًا لأحكام نظام حماية البيانات الشخصية (PDPL) ولوائحه التنفيذية والأنظمة ذات العلاقة المعمول بها في المملكة العربية السعودية. نوضح فيما يلي أنواع البيانات الشخصية التي نقوم بجمعها، وآلية استخدامها، وأغراض المعالجة، وحالات المشاركة، إضافة إلى حقوق أصحاب البيانات وفقًا لأحكام نظام حماية البيانات الشخصية (PDPL) ولوائحه التنفيذية.",
          },
        ],
      },
      {
        id: 2,
        title: "البيانات الشخصية التي تجمعها NowPay",
        description: [
          {
            type: "none",
            content:
              "نلتزم بحماية بياناتك الشخصية وفقًا لأنظمة حماية البيانات المعمول بها وهذه سياسة الخصوصية. فيما يلي نوضح بشكل مبسّط أنواع البيانات الشخصية التي نجمعها، وكيف نستخدمها، ومتى قد نشاركها، والحقوق التي تتمتع بها.",
          },
        ],
      },
      {
        id: 3,
        title: "جمع البيانات من زوار الموقع والتطبيق",
        description: [
          {
            type: "none",
            content:
              "مثل معظم مشغلي المواقع والتطبيقات، تجمع NowPay معلومات غير محددة للهوية تُتيحها عادةً متصفحات الويب والخوادم، مثل: نوع المتصفح اللغة المفضل الموقع المُحيل تاريخ ووقت كل طلب زيارة. الغرض من جمع هذه البيانات هو فهم كيفية استخدام الزوار للموقع والتطبيق بشكل أفضل وتحسين الخدمات المقدمة. ومن وقت لآخر، قد تقوم NowPay بمشاركة أو نشر بيانات مجمّعة وغير محددة للهوية، مثل نشر تقارير عامة حول اتجاهات الاستخدام.",
          },
          {
            type: "none",
            content:
              "كما تقوم NowPay بجمع بيانات قد تكون محددة للهوية في بعض الحالات، مثل عناوين بروتوكول الإنترنت (IP)، وذلك للمستخدمين المسجلين أو للمستخدمين الذين يتركون تعليقات على مدونة NowPay.",
          },
          {
            type: "none",
            content:
              "ولا تقوم NowPay بالإفصاح عن عناوين IP الخاصة بالمستخدمين المسجلين أو المعلّقين إلا في نفس الحالات التي يتم فيها الإفصاح عن البيانات الشخصية الأخرى، وذلك وفقًا لما هو موضح في هذه السياسة.",
          },
        ],
      },
      {
        id: 4,
        title: "جمع المعلومات الشخصية المحددة للهوية",
        description: [
          {
            type: "none",
            content:
              "قد يختار بعض زوار موقع أو تطبيق NowPay التفاعل معنا بطرق تتطلب جمع بيانات شخصية محددة للهوية.",
          },
          {
            type: "none",
            content: "يعتمد نوع وكمية البيانات التي يتم جمعها على طبيعة هذا التفاعل.",
          },
          {
            type: "none",
            content: "على سبيل المثال، عند التسجيل في مدونة NowPay، قد نطلب من الزائر تزويدنا بـ:",
          },
          { type: "bullet", content: "اسم المستخدم" },
          { type: "bullet", content: "عنوان البريد الإلكتروني" },
        ],
      },
      {
        id: 5,
        title: "جمع البيانات من تطبيق iOS أو Android",
        description: [
          {
            type: "none",
            content:
              "يقوم تطبيق iOS / Android بجمع البيانات التالية، ولا يتم مشاركتها مع أي طرف ثالث إلا إذا تم النص على خلاف ذلك ووفقًا لنظام حماية البيانات الشخصية (PDPL):",
          },
          { type: "bullet", content: "الموقع: موقع تقريبي، موقع دقيق" },
          {
            type: "bullet",
            content: "البيانات الشخصية: الاسم، عنوان البريد الإلكتروني، معرفات المستخدم، العنوان، رقم الهاتف",
          },
          {
            type: "bullet",
            content:
              "البيانات المالية: بيانات الدفع الخاصة بالمستخدم وأي بيانات مالية أخرى (مثل الراتب أو الالتزامات المالية)",
          },
          { type: "bullet", content: "الصور ومقاطع الفيديو: الصور" },
          { type: "bullet", content: "جهات الاتصال: جهات الاتصال" },
          {
            type: "bullet",
            content: "نشاط التطبيق: تفاعلات المستخدم داخل التطبيق، سجل البحث داخل التطبيق، وإجراءات أخرى",
          },
          { type: "bullet", content: "معلومات التطبيق وأداؤه: سجلات الأعطال وبيانات أداء التطبيق الأخرى" },
          { type: "bullet", content: "بيانات الجهاز أو المعرّفات الأخرى: معرف الجهاز" },
        ],
      },
      {
        id: 6,
        title: "البيانات التي يتم جمعها أثناء تسجيل الحساب",
        description: [
          {
            type: "none",
            content:
              "لغرض من عملية المعالجة هذه هو إنشاء حسابات المستخدمين وإدارتها على التطبيق. وخلال عملية التسجيل، سنقوم بجمع ومعالجة البيانات الشخصية التالية:",
          },
          { type: "bullet", content: "الاسم الأول" },
          { type: "bullet", content: "اسم العائلة" },
          { type: "bullet", content: "اسم الجد" },
          { type: "bullet", content: "اسم العائلة (اللقب)" },
          { type: "bullet", content: "الرقم الوظيفي" },
          { type: "bullet", content: "رقم الجوال" },
          { type: "bullet", content: "عنوان البريد الإلكتروني" },
          { type: "bullet", content: "رقم الهوية الوطنية أو رقم الإقامة" },
          { type: "bullet", content: "اسم البنك" },
          { type: "bullet", content: "اسم صاحب الحساب" },
          { type: "bullet", content: "رقم الآيبان (IBAN)" },
        ],
      },
      {
        id: 7,
        title: "البيانات التي يتم جمعها من صفحة التسجيل في الموقع الإلكتروني",
        description: [
          {
            type: "none",
            content:
              "نقوم بجمع البيانات الشخصية من زوار الموقع الإلكتروني أو مدونة الموقع بهدف تحسين تجربة المستخدم وتقديم محتوى مناسب لهم. وقد تشمل أنواع البيانات التي يتم جمعها ما يلي:",
          },
          { type: "bullet", content: "الأسماء" },
          { type: "bullet", content: "المسمى الوظيفي" },
          { type: "bullet", content: "عناوين البريد الإلكتروني" },
          { type: "bullet", content: "رقم الهاتف" },
          { type: "bullet", content: "اسم الشركة" },
          { type: "bullet", content: "حجم الشركة" },
          { type: "bullet", content: "أي معلومات إضافية يتم تقديمها طوعًا من خلال التعليق أو الرسالة." },
        ],
      },
      {
        id: 8,
        title: "البيانات التي يتم جمعها من طلبات التوظيف",
        description: [
          {
            type: "none",
            content:
              "الغرض من عملية المعالجة هذه هو تقييم طلبات التوظيف وإدارة إجراءات التقديم. وخلال هذه العملية، سنقوم بجمع ومعالجة البيانات الشخصية التالية:",
          },
          { type: "bullet", content: "الاسم الأول" },
          { type: "bullet", content: "اسم العائلة" },
          { type: "bullet", content: "عنوان البريد الإلكتروني" },
          { type: "bullet", content: "العنوان" },
          { type: "bullet", content: "الهاتف" },
          { type: "bullet", content: "السيرة الذاتية (CV)" },
          { type: "bullet", content: "رقم الهوية الوطنية" },
          { type: "bullet", content: "تاريخ الميلاد" },
        ],
      },
      {
        id: 9,
        title: "حقوقك في الوصول إلى المعلومات وتعديلها",
        description: [
          {
            type: "none",
            content:
              "يمكنك الوصول إلى مجموعة واسعة من المعلومات حول حسابك وتفاعلاتك مع المنصة، مما يتيح لك الاطلاع على بياناتك، وفي بعض الحالات، تحديثها. وتشمل أمثلة المعلومات التي يمكنك الوصول إليها عبر المنصة ما يلي:",
          },
          {
            type: "bullet",
            content: "إشعارات البريد الإلكتروني: إدارة تفضيلات وإعدادات إشعارات البريد الإلكتروني الخاصة بك.",
          },
          {
            type: "bullet",
            content:
              "البيانات الشخصية: الوصول إلى بياناتك الشخصية وتحديثها، بما في ذلك الاسم، وعنوان البريد الإلكتروني، وكلمة المرور، ورقم الهاتف، وتفضيلات التواصل، وإعدادات الإعلانات المخصصة.",
          },
        ],
      },
      {
        id: 10,
        title: "عبر الإنترنت:",
        description: [
          {
            type: "none",
            content:
              "في حال استلامك إشعارات تسويقية عبر التطبيق أو البريد الإلكتروني، يمكنك تحديث إعداداتك من خلال قسم الإشعارات في التطبيق.",
          },
          {
            type: "none",
            content:
              "حقوق صاحب البيانات وفقًا لنظام حماية البيانات الشخصية (PDPL). وفقًا لنظام حماية البيانات الشخصية في المملكة العربية السعودية، تتمتع بالحقوق التالية:",
          },
          { type: "numbered", content: "١. الحق في الإحاطة علماً" },
          { type: "numbered", content: "٢. الحق في الوصول إلى البيانات الشخصية" },
          { type: "numbered", content: "٣. الحق في طلب الوصول إلى البيانات الشخصية" },
          { type: "numbered", content: "٤. الحق في تصحيح وتحديث البيانات الشخصية" },
          { type: "numbered", content: "٥. الحق في محو البيانات الشخصية" },
        ],
      },
      {
        id: 11,
        title: "استخدام ملفات تعريف الارتباط (Cookies) وتقنيات التتبع",
        description: [
          {
            type: "none",
            content:
              "لتحسين تجربتك على الإنترنت، تستخدم NowPay ملفات تعريف الارتباط (Cookies) وتقنيات مشابهة مقدمة من جهات أخرى لعرض محتوى مخصص، وتقديم إعلانات ذات صلة، وحفظ تفضيلاتك على جهازك.",
          },
          {
            type: "none",
            content:
              "ملف تعريف الارتباط هو ملف صغير يحتوي على معلومات يتم تخزينها على جهاز الزائر بواسطة الموقع الإلكتروني أو التطبيق، ويقوم المتصفح بإرسال هذه المعلومات إلى الموقع أو التطبيق في كل مرة تتم فيها الزيارة.",
          },
          {
            type: "none",
            content:
              "تستخدم NowPay ملفات تعريف الارتباط للمساعدة في التعرف على الزوار وتتبع استخدامهم للموقع أو التطبيق وتفضيلات الوصول لديهم. ويمكن للزوار الذين لا يرغبون في استخدام ملفات تعريف الارتباط ضبط إعدادات المتصفح لرفضها قبل استخدام موقع أو تطبيق NowPay. يرجى ملاحظة أن بعض الميزات قد لا تعمل بشكل صحيح في حال تعطيل ملفات تعريف الارتباط",
          },
          {
            type: "none",
            content:
              "وباستخدامك للموقع أو التطبيق دون تغيير إعدادات ملفات تعريف الارتباط، فإنك تقر وتوافق على استخدام NowPay لملفات تعريف الارتباط. ولمزيد من التفاصيل حول كيفية استخدام ملفات تعريف الارتباط وإدارتها، يرجى الرجوع إلى سياسة ملفات تعريف الارتباط الخاصة بنا.",
          },
        ],
      },
      {
        id: 12,
        title: "التجارة الإلكترونية",
        description: [
          {
            type: "none",
            content:
              "يُطلب من المستخدمين الذين يجرون معاملات مع NowPay، من خلال شراء خدمات أو منتجات NowPay، تقديم معلومات إضافية عند الحاجة، بما في ذلك البيانات الشخصية والبيانات المالية اللازمة لإتمام المعاملة.",
          },
          {
            type: "none",
            content:
              "تقوم NowPay بجمع هذه المعلومات فقط بالقدر الضروري أو المناسب لتحقيق الغرض من تفاعل المستخدم مع NowPay ومعالجة ولا تقوم NowPay بالإفصاح عن البيانات الشخصية المحددة للهوية إلا كما هو موضح في هذه السياسة. كما يحق للمستخدمين دائمًا الامتناع عن تقديم بيانات شخصية محددة للهوية، مع العلم أن ذلك قد يمنعهم من الاستفادة من بعض الخدمات أو الميزات المتاحة عبر الموقع أو التطبيق.",
          },
        ],
      },
      {
        id: 13,
        title: "مشاركة البيانات",
        description: [
          {
            type: "none",
            content:
              "تُعد معلومات العملاء جزءًا أساسيًا من عملياتنا. ولا نقوم بمشاركة بياناتك إلا وفقًا لما هو موضح أدناه، ومع جهات تلتزم بتطبيق ممارسات حماية للبيانات لا تقل عن تلك الواردة في سياسة الخصوصية هذه.",
          },
          { type: "bullet", content: "الجهات التابعة وغير التابعة:" },
          {
            type: "dashed",
            content:
              "- لتقديم خدماتنا، قد تتعاون NowPay مع شركات تابعة وموفري خدمات من أطراف ثالثة غير تابعين، مثل مقدمي الخدمات التكنولوجية، وشركاء الالتزام وإدارة المخاطر، ومقدمي خدمات التسويق، وشركاء معالجة المدفوعات أو المعاملات. يتم منح هذه الأطراف حق الوصول فقط إلى المعلومات اللازمة لأداء وظائفهم المحددة نيابة عننا.",
          },
          {
            type: "dashed",
            content:
              "- تضمن NowPay أن مثل هؤلاء الأطراف الثالثة مُلزمون تعاقديًا بعدم استخدام البيانات الشخصية لأي غرض آخر غير تقديم الخدمات لصالح NowPay، ومطالبون بالحفاظ على سرية وأمن تلك المعلومات. باستخدامك لخدماتنا، فإنك تقر وتوافق على نقل معلوماتك وتخزينها واستخدامها والإفصاح عنها لهذه الأطراف وفقًا لسياسة الخصوصية هذه.",
          },
          { type: "bullet", content: "التسويق والعروض الترويجية:" },
          {
            type: "dashed",
            content:
              "- قد نستخدم معلوماتك لإبلاغك بخدماتنا وميزاتنا وتحديثاتنا والعروض التي قد تكون ذات صلة بك، وكذلك لتحسين تجربتك على منصتنا. قد يشمل ذلك رسائل متعلقة بالخدمة والإعلان عن خدمات جديدة أو مطوّرة، وتحديثات النظام، والتحسينات، والعروض الترويجية، والفعاليات ذات الصلة.",
          },
          {
            type: "dashed",
            content:
              "- قد نتصل بك عبر قنوات متعددة، بما في ذلك البريد الإلكتروني والمكالمات الهاتفية وإشعارات الدفع وإشعارات الويب والرسائل داخل التطبيق وغيرها من وسائل الاتصال المتعلقة بالمنصة وذلك وفقًا للأنظمة المعمول بها وتفضيلات التواصل الخاصة بك.",
          },
          { type: "bullet", content: "الاستخدام من قبل أطراف ثالثة:" },
          {
            type: "dashed",
            content:
              "- قد نسمح لأطراف ثالثة باستخدام بياناتك في بعض الحالات، مثل تزويد المعلنين ببيانات تساعدهم على استهداف فئات محددة وعرض الإعلانات على الجمهور المناسب، وذلك بما يحقق التزاماتنا تجاه المعلنين ووفقًا للأنظمة المعمول بها.",
          },
          { type: "bullet", content: "نقل الأعمال:" },
          {
            type: "dashed",
            content:
              "- في حال حدوث استحواذ على الأعمال أو نقل للأصول، قد تكون معلومات العملاء ضمن الأصول التي يتم نقلها.",
          },
          { type: "bullet", content: "حماية منصتنا والآخرين:" },
          {
            type: "dashed",
            content:
              "- قد نقوم بالإفصاح عن الحسابات أو أي معلومات أخرى إذا رأينا أن ذلك ضروري للامتثال للالتزامات النظامية، أو لدعم التحقيقات التي تجريها الجهات المختصة، أو لحماية حقوق أو ممتلكات أو سلامة مستخدمينا أو الآخرين. وقد يشمل ذلك مشاركة المعلومات مع شركات أو جهات أخرى لأغراض مثل مكافحة الاحتيال وإدارة مخاطر الائتمان.",
          },
        ],
      },
      {
        id: 14,
        title: "الاحتفاظ بالبيانات",
        description: [
          {
            type: "none",
            content:
              "ما لم يُنص على خلاف ذلك في سياسة الخصوصية هذه، تحتفظ NowPay بالبيانات الشخصية فقط للمدة اللازمة لتحقيق الأغراض التي جُمعت من أجلها بما في ذلك تقديم الخدمات والامتثال للالتزامات النظامية والتنظيمية والتعاقدية.",
          },
          {
            type: "none",
            content:
              "بعد انتهاء مدة الاحتفاظ المعتمدة، يتم حذف البيانات الشخصية بشكل آمن، أو إخفاء هويتها، أو التخلص منها بطريقة مناسبة، ما لم يكن الاحتفاظ بها مسموحًا به أو مطلوبًا بموجب الأنظمة أو اللوائح المعمول بها.",
          },
          {
            type: "none",
            content:
              "تطبق NowPay إجراءات فنية وتنظيمية مناسبة، بما في ذلك حماية البيانات من خلال التصميم وبالوضع الافتراضي، لضمان الاحتفاظ بالبيانات الشخصية للحد الأدنى من المدة اللازمة فقط لتحقيق الأغراض المحددة.",
          },
        ],
      },
      {
        id: 15,
        title: "أمن البيانات",
        description: [
          {
            type: "none",
            content:
              "نقوم بتطبيق إجراءات وضوابط فنية وتنظيمية شاملة، بما في ذلك السياسات والإجراءات التشغيلية، لتحقيق مستوى مناسب من أمن المعلومات يتوافق مع المخاطر المرتبطة بمعالجة البيانات. ويتم ذلك وفقًا لأفضل المعايير والممارسات الدولية، بهدف حماية خصوصية البيانات الشخصية وسريتها وسلامتها وتوافرها.",
          },
          {
            type: "none",
            content:
              "إن حماية بياناتك الشخصية تمثل أولوية لدينا. ونتخذ عناية كبيرة في نقل بياناتك الشخصية بشكل آمن من جهازك (مثل الكمبيوتر أو الهاتف الذكي أو أي جهاز إلكتروني آخر) إلى خوادمنا. وتشمل ممارساتنا الأمنية استخدام وسائل حماية معتمدة في المجال، مثل جدران الحماية (Firewalls)، وبروتوكول أمان طبقة النقل (TLS)، وتقنيات التشفير، وذلك للحفاظ على سرية بياناتك.",
          },
          {
            type: "none",
            content:
              "كما قمنا بوضع وتطبيق ضوابط فنية وتنظيمية قوية، وسياسات وإجراءات مناسبة، لحماية بياناتك الشخصية من الفقدان العرضي، أو الوصول غير المصرح به، أو الاستخدام أو التعديل أو الإفصاح غير المصرح به.",
          },
          {
            type: "none",
            content:
              "ومع ذلك، فإن أمن بياناتك الشخصية يعتمد أيضًا على سلوكك. ويجب عليك الحفاظ على سرية كلمة المرور الخاصة بك وعدم مشاركتها مع أي شخص. ورغم حرصنا على حماية بياناتك، إلا أن نقل المعلومات عبر الإنترنت لا يكون آمنًا بشكل كامل دائمًا، ولا يمكننا ضمان أمن البيانات التي يتم نقلها إلى منصتنا، ويتم أي نقل للبيانات على مسؤوليتك الخاصة. ولحمايتك، نوصي بتوخي الحذر عند مشاركة أي بيانات عبر الإنترنت.",
          },
        ],
      },
      {
        id: 16,
        title: "تحديث أو تغيير سياسة الخصوصية",
        description: [
          {
            type: "none",
            content:
              "قد تقوم NowPay بتحديث أو تعديل سياسة الخصوصية هذه من وقت لآخر، وفقًا لتقديرها. وعلى الرغم من أن معظم التغييرات قد تكون بسيطة فإننا نشجعك على مراجعة هذه الصفحة بشكل دوري. ويُعد استمرارك في استخدام خدمات NowPay بعد أي تعديل موافقة منك على سياسة الخصوصية المحدثة.",
          },
          {
            type: "none",
            content:
              "لا يتم تخزين أو بيع أو مشاركة أو تأجير أو تأجير بالانتفاع أي معلومات خاصة ببطاقات الائتمان أو الخصم أو أي بيانات شخصية محددة للهوية مع أي أطراف ثالثة.",
          },
          {
            type: "none",
            content:
              "كما قد يتم تحديث شروط وأحكام NowPay وسياسات الخدمة من حين لآخر لتلبية المتطلبات النظامية أو التنظيمية أو التشغيلية. ونشجع العملاء على مراجعة هذه الأقسام بشكل منتظم. وتصبح التعديلات سارية المفعول فور نشرها.",
          },
          {
            type: "none",
            content: "تم آخر تحديث لسياسة الخصوصية هذه بتاريخ 16 ديسمبر 2025.",
          },
        ],
      },
      {
        id: 17,
        title: "تواصل معنا",
        description: [
          {
            type: "none",
            content:
              "إذا كان لديك أي استفسار أو ملاحظة تتعلق ببياناتك الشخصية على الموقع الإلكتروني أو التطبيق، يرجى التواصل معنا عبر:",
          },
          { type: "bullet", content: "البريد الإلكتروني: Privacy@NowPaysaudi.com" },
        ],
      },
    ],

    questions: [
      {
        id: 1,
        question: "ما الذي يتعين عليّ فعله لتسجيل شركتي أو شركة أخرى في NowPay؟",
        answers: ["يمكنك مراسلتنا عبر البريد الإلكتروني: benefitsteam@nowpay.cash"],
      },
      {
        id: 2,
        question: "لماذا حدّي منخفض؟",
        answers: ["قد يكون حسابك بانتظار موافقة قسم الموارد البشرية، وسيتم تحديثه بمجرد اكتمال العملية."],
      },
      {
        id: 3,
        question: "ماذا تعني الحالات المختلفة في شاشة العمليات؟",
        answers: [
          "Processing: ما زلنا نقوم بمعالجة طلبك.",
          "Transferring: طلبك قيد الإرسال.",
          "Completed: تم إكمال طلبك.",
        ],
      },
      {
        id: 4,
        question: "أرغب في إلغاء طلب. ماذا يجب أن أفعل؟",
        answers: [
         'ضغط على أيقونة “الراتب” في الشريط أسفل الصفحة الرئيسية.',
         'اختر الطلب الذي ترغب في إلغائه.',
         'اضغط على زر “تعديل”.',
         'اختر “إلغاء العملية”.',
         'إذا لم تتمكن من رؤية زر الإلغاء، فهذا يعني أن الطلب قد تمت معالجته بالفعل وهو الآن في طريقه.'
        ],
      },
      {
        id: 5,
        question: "كيف يتم خصم المبالغ المستحقة؟",
        answers: [
          'يتم خصم المبلغ المستحق تلقائيًا من رواتبك الشهرية المستقبلية.',
          'لا حاجة لإجراء تحويلات بنكية أو التأكد من وجود رصيد كافٍ في حسابك.',
        ],
      },
    ],
    termsAndConditions: 'الشروط والأحكام',
    TermsConditions1: 'المقدمة',
    TermsConditionsDesc1: [
      'تحدد هذه الشروط والأحكام القواعد واللوائح الخاصة باستخدام موقع/تطبيق Nowpay.',
      'يقع مقر Nowpay في: EKDA8868 الملك فيصل ابن عبدالعزيز الفرعي - حي الروابي - الخبر 34421 - المملكة العربية السعودية.',
      'بدخولك إلى هذا الموقع/التطبيق، نفترض أنك توافق على هذه الشروط والأحكام بالكامل. لا تستمر في استخدام موقع/تطبيق Nowpay إذا كنت لا توافق على جميع الشروط والأحكام المذكورة في هذه الصفحة.'
    ],
    TermsConditions2: 'التعريفات والمصطلحات',
    TermsConditionsDesc2: [
      'شير مصطلح "العميل" و"أنت" و"الخاص بك" إليك أنت، الشخص الذي يدخل إلى هذا الموقع/التطبيق ويقبل شروط وأحكام الشركة. يشير مصطلح "الشركة" و"أنفسنا" و"نحن" و"الخاص بنا" و"لنا" إلى شركتنا. يشير مصطلح "الطرف" أو "الأطراف" أو "نحن" إلى كل من العميل وأنفسنا، أو إما العميل أو أنفسنا.',
      'تشير جميع المصطلحات إلى العرض والقبول والنظر في الدفع اللازم للقيام بعملية مساعدتنا للعميل بالطريقة الأنسب، سواء من خلال اجتماعات رسمية ذات مدة محددة، أو أي وسيلة أخرى، لغرض صريح هو تلبية احتياجات العميل فيما يتعلق بتوفير الخدمات/المنتجات المعلنة للشركة، وفقًا للقانون السائد في المملكة العربية السعودية وبموجبه.'  
    ],
    TermsConditions3: 'ملفات تعريف الارتباط (الكوكيز)',
    TermsConditionsDesc3: [
      'نحن نستخدم ملفات تعريف الارتباط (الكوكيز). باستخدامك لموقع/تطبيق Nowpay، فإنك توافق على استخدام ملفات تعريف الارتباط وفقًا لسياسة الخصوصية الخاصة بـ Nowpay.',
      'تستخدم معظم مواقع الويب/التطبيقات التفاعلية الحديثة ملفات تعريف الارتباط لتمكيننا من استرداد تفاصيل المستخدم في كل زيارة. تُستخدم ملفات تعريف الارتباط في بعض مناطق موقعنا لتمكين وظائف هذه المنطقة وسهولة الاستخدام للأشخاص الذين يزورونها. قد تستخدم بعض شركائنا التابعين/الإعلانيين أيضًا ملفات تعريف الارتباط.'
    ],
    TermsConditions4: 'يجب عليك عدم:',
    TermsConditionsDesc4: [
      'إعادة نشر المواد من NowPay',
      'بيع أو تأجير أو منح ترخيص فرعي للمواد من NowPay',
      'إعادة إنتاج أو تكرار أو نسخ المواد من NowPay',
      'إعادة توزيع المحتوى من Nowpay (ما لم يكن المحتوى مخصصًا للتوزيع على وجه التحديد)', 
    ],
    TermsConditions5: 'الترخيص وحقوق الملكية الفكرية',
    TermsConditionsDesc5: [
      'ما لم يُذكر خلاف ذلك، تمتلك Nowpay و/أو مانحو التراخيص التابعون لها حقوق الملكية الفكرية لجميع المواد الموجودة على Nowpay. جميع حقوق الملكية الفكرية محفوظة.',
      'يمكنك عرض و/أو طباعة صفحات من NowPay لاستخدامك الشخصي مع مراعاة القيود المنصوص عليها في هذه الشروط والأحكام.', 
    ],
    TermsConditions6: 'الارتباط التشعبي بمحتوانا',
    TermsConditionsDesc6: [
      'يمكن للمنظمات التالية الارتباط بموقعنا/تطبيقنا دون موافقة خطية مسبقة:',
      'الهيئات الحكومية',
      'محركات البحث',
      'المنظمات الإخبارية',
      'موزعو الدليل عبر الإنترنت عندما يدرجوننا في الدليل',
      'الشركات المعتمدة على نطاق النظام',
      {bold: 'استثناء:', description: 'المنظمات غير الربحية التي تطلب التبرعات، ومراكز التسوق الخيرية، ومجموعات جمع التبرعات الخيرية لا يُسمح لها بالارتباط بموقعنا/تطبيقنا.'}
    ],
    TermsConditions7: 'شروط الارتباط',
    TermsConditionsDesc7: [
      'قد تربط المنظمات بصفحتنا الرئيسية أو المنشورات أو معلومات الموقع/التطبيق الأخرى طالما أن الرابط:',
      'ليس مضللاً بأي شكل من الأشكال',
      'لا يوحي زوراً برعاية أو تأييد أو موافقة الطرف الذي يربط ومنتجاته أو خدماته',
      'يتناسب مع سياق موقع الطرف الذي يربط', 
    ],
    TermsConditions8: 'طلبات الارتباط',
    TermsConditionsDesc8: [
      'إذا كنت مهتمًا بالارتباط بموقعنا/تطبيقنا، فيجب عليك إخطارنا بإرسال بريد إلكتروني إلى: team[at]nowpay.com',
      'يرجى تضمين:',
      'اسمك واسم مؤسستك',
      'معلومات الاتصال (رقم الهاتف و/أو عنوان البريد الإلكتروني)',
      'عنوان URL لموقعك',
      'قائمة بعناوين URL التي تنوي الربط منها إلى موقعنا',
      'قائمة بعناوين URL الموجودة على موقعنا والتي ترغب في الارتباط بها',
      'انتظر من 2 إلى 3 أسابيع للحصول على رد.'
    ],
    TermsConditions9: 'الإطارات الداخلية (Iframes)',
    TermsConditionsDesc9: 'بدون موافقة مسبقة وإذن خطي صريح، لا يجوز لك إنشاء إطارات حول صفحات الويب الخاصة بنا أو استخدام تقنيات أخرى تغير بأي شكل من الأشكال العرض المرئي أو مظهر موقعنا.',
    TermsConditions10: 'حفظ الحقوق',
    TermsConditionsDesc10: [
      'نحتفظ بالحق في أي وقت وبتقديرنا الخاص في أن نطلب منك إزالة جميع الروابط أو أي رابط معين لموقعنا/تطبيقنا. أنت توافق على إزالة جميع الروابط إلى موقعنا/تطبيقنا فورًا عند هذا الطلب.',
      'كما نحتفظ بالحق في تعديل هذه الشروط والأحكام وسياسة الارتباط الخاصة بها في أي وقت. من خلال الاستمرار في الارتباط بموقعنا، فإنك توافق على الالتزام بشروط وأحكام الارتباط هذه والامتثال لها.'
    ],
    TermsConditions11: 'إزالة الروابط من موقعنا/تطبيقنا',
    TermsConditionsDesc11: [
      'إذا وجدت أي رابط على موقعنا/تطبيقنا أو أي موقع/تطبيق مرتبط به غير مقبول لأي سبب، يمكنك الاتصال بنا بشأن هذا الأمر. سننظر في طلبات إزالة الروابط ولكن لن يكون لدينا أي التزام بالقيام بذلك أو بالرد عليك مباشرة.',
      'بينما نسعى جاهدين لضمان صحة المعلومات الموجودة على هذا الموقع/التطبيق، فإننا لا نضمن اكتمالها أو دقتها؛ ولا نلتزم بضمان بقاء الموقع/التطبيق متاحًا أو أن المواد الموجودة على الموقع/التطبيق محدثة.'
    ],
    TermsConditions12: 'مسؤولية المحتوى',
    TermsConditionsDesc12: [
      'لن نتحمل أي مسؤولية أو التزام عن أي محتوى يظهر على موقعك/تطبيقك. أنت توافق على تعويضنا والدفاع عنا ضد جميع المطالبات الناشئة عن أو بناءً على موقعك/تطبيقك.',
      'لا يجوز ظهور أي روابط على أي صفحة على موقعك/تطبيقك أو ضمن أي سياق يحتوي على محتوى أو مواد قد يتم تفسيرها على أنها تشهيرية أو فاحشة أو إجرامية، أو التي تنتهك أو تنتهك بطريقة أخرى، أو تدعو إلى الانتهاك أو الانتهاك الآخر لأي حقوق طرف ثالث.'
    ],
    TermsConditions13: 'إخلاء المسؤولية',
    TermsConditionsDesc13: [
      'إلى أقصى حد يسمح به القانون المعمول به، نستبعد جميع التمثيلات والضمانات والشروط المتعلقة بموقعنا/تطبيقنا واستخدام هذا الموقع/التطبيق (بما في ذلك، دون حصر، أي ضمانات ضمنية بموجب القانون فيما يتعلق بالجودة المرضية والملاءمة للغرض و/أو استخدام العناية والمهارة المعقولة).',
      'لن يؤدي أي شيء في إخلاء المسؤولية هذا إلى:',
      'الحد من أو استبعاد مسؤوليتنا أو مسؤوليتك عن الوفاة أو الإصابة الشخصية الناتجة عن الإهمال',
      'الحد من أو استبعاد مسؤوليتنا أو مسؤوليتك عن الاحتيال أو التحريف الاحتيالي',
      'الحد من أي من التزاماتنا أو التزاماتك بأي طريقة غير مسموح بها بموجب القانون المعمول به',
      'استبعاد أي من التزاماتنا أو التزاماتك التي قد لا يتم استبعادها بموجب القانون المعمول به'
    ],
    TermsConditions14: 'القانون الحاكم والاختصاص القضائي',
    TermsConditionsDesc14: 'يخضع أي نزاع أو مطالبة تنشأ عن أو فيما يتعلق بهذا الموقع/التطبيق ويفسر وفقًا لقوانين المملكة العربية السعودية.\nالمملكة العربية السعودية هي بلد موطننا.',
    TermsConditions15: 'القيود العمرية',
    TermsConditionsDesc15: 'يُحظر على القاصرين الذين تقل أعمارهم عن 18 عامًا التسجيل كمستخدم لهذا الموقع/التطبيق ولا يُسمح لهم بإجراء معاملات أو استخدام الموقع/التطبيق.',
    TermsConditions16: 'معلومات الدفع',
    TermsConditionsDesc16: [
      'إذا قمت بالدفع مقابل منتجاتنا أو خدماتنا على موقعنا/تطبيقنا، فسيتم تقديم التفاصيل التي يُطلب منك إرسالها مباشرة إلى مزود الدفع الخاص بنا عبر اتصال آمن.',
      'يجب على حامل البطاقة/مستخدم الخدمة الاحتفاظ بنسخة من سجلات المعاملات وسياسات وقواعد التاجر.',
      'نحن نقبل المدفوعات عبر الإنترنت باستخدام بطاقات الائتمان/الخصم فيزا وماستركارد.',
    ],
    news: [
      {
        newsDate: "٢٢ يناير ٢٠٢٦",
        newsTitle: "NowPay المصرية تدخل السوق السعودي بشراكة مع تسهيل بقيمة 20 مليون دولار",
        newsDescription: "تطلق شركة NowPay للتقنية المالية المصرية في المملكة العربية السعودية من خلال NowAccess، وهي شركة مشتركة مع تسهيل",
        newsLink: "https://www.wamda.com/2026/01/egypt-nowpay-enters-saudi-market-20m-backed-tasheel-partnership",
        newsImage: "/news/news1.webp",
        media: "Wamda",
      },
      {
        newsDate: "٢٥ يناير ٢٠٢٦",
        newsTitle: "NowPay تدخل السوق السعودي بشراكة تسهيل بقيمة 20 مليون دولار",
        newsDescription: "تطلق شركة NowPay المصرية للتقنية المالية NowAccess في المملكة العربية السعودية من خلال مشروع مشترك بقيمة 20 مليون دولار مع تسهيل",
        newsLink: "https://cairoscene.com/Business/NowPay-Enters-Saudi-Market-With-20M-Tas-heel-Partnership",
        newsImage: "/news/news2.webp",
        media: "Cairo Scene",
      },
      {
        newsDate: "٢٣ يناير ٢٠٢٦",
        newsTitle: "NowPay تدخل السوق السعودي",
        newsDescription: "دخلت شركة NowPay المصرية للتقنية المالية السوق السعودي من خلال إطلاق NowAccess، وهو مشروع مشترك مع تسهيل، الذراع التمويلي الاستهلاكي",
        newsLink: "https://www.islamicfinancenews.com/nowpay-enters-saudi-market.html",
        newsImage: "/news/news3.svg",
        media: "Islamic Finance News",
      },
      {
        newsDate: "٢٢ يناير ٢٠٢٦",
        newsTitle: "NowPay تحصل على 20 مليون دولار للتوسع في المملكة العربية السعودية",
        newsDescription: "ستطلق شركة التكنولوجيا المالية منصتها للرواتب والعافية المالية من خلال مشروع مشترك جديد",
        newsLink: "https://www.startupresearcher.com/news/nowpay-secures-usd20-million-to-expand-into-saudi-arabia",
        newsImage: "/news/news4.svg",
        media: "Startup Researcher",
      },
      {
        newsDate: "٢٢ يناير ٢٠٢٦",
        newsTitle: "NowPay المصرية تجمع 20 مليون دولار لتوسيع خدمات الرواتب المتوافقة مع الشريعة في السعودية",
        newsDescription: "بدلاً من التعامل مع اللوائح السعودية بمفردها، تتخذ NowPay المسار الأسرع من خلال مشروع مشترك بقيمة 20 مليون دولار مع تسهيل",
        newsLink: "https://arabfounders.net/en/nowpay-enters-saudi-arabia-nowaccess-tasheel-20m-jv/",
        newsImage: "/news/news5.webp",
        media: "Arab Founders",
      },
      {
        newsDate: "٢٤ يناير ٢٠٢٦",
        newsTitle: "NowPay المصرية تجمع 20 مليون دولار لنقل منصة الرواتب والأجور المكتسبة إلى السعودية",
        newsDescription: "تواصل NowPay توسعها الإقليمي مع دخولها السوق السعودي من خلال مشروع مشترك مع تسهيل",
        newsLink: "https://techbuild.africa/egyptian-fintech-nowpay-20m-payroll-earned-wage/",
        newsImage: "/news/news6.svg",
        media: "TechBuild Africa",
      },
      {
        newsDate: "١٩ يونيو ٢٠٢٥",
        newsTitle: "تسهيل وNowPay تطلقان 'Now Access' لرقمنة معالجة الأجور في السعودية",
        newsDescription: "أعلنت تسهيل وNowPay عن إطلاق Now Access لتحويل معالجة الأجور رقمياً في المملكة العربية السعودية",
        newsLink: "https://wasssl.com/tasheel-and-nowpay-launch-now-access-to-digitize-wage-processing-in-saudi-arabia/",
        newsImage: "/news/news7.webp",
        media: "Wasssl",
      },
      {
        newsDate: "٢٢ يناير ٢٠٢٦",
        newsTitle: "NowPay المصرية تحصل على 20 مليون دولار لإطلاق مشروع مشترك في السعودية",
        newsDescription: "تحصل NowPay المصرية على 20 مليون دولار لإطلاق مشروعها المشترك في المملكة العربية السعودية",
        newsLink: "https://launchbaseafrica.com/2026/01/22/egypts-nowpay-lands-20m-to-launch-saudi-joint-venture/",
        newsImage: "/news/news8.svg",
        media: "LaunchBase Africa",
      },
    ],
    readArticle: "اقرأ المقال",
    articleTitle: "10 مزايا للرفاهية المالية للحفاظ على أفضل المواهب السعودية في 2025",
    articalContent: [
      {
        id: 1,
        title: "لماذا تهم الرفاهية المالية في المملكة العربية السعودية",
        description: [
          {
            type: "none",
            content:
              "يعد الضغط المالي أحد الأسباب الرئيسية للقلق في مكان العمل على مستوى العالم، والمملكة العربية السعودية ليست استثناءً. مع التطور السريع لاقتصاد المملكة في ظل رؤية 2030، يواجه الموظفون تحديات وفرص مالية فريدة. إليك عشر نصائح أساسية لمساعدتك على تحقيق الرفاهية المالية في عام 2025.",
          },
        ],
      },
      {
        id: 2,
        title: "1. أتقن قاعدة الميزانية 50/30/20",
        description: [
          {
            type: "none",
            content:
              "واحدة من أكثر استراتيجيات الميزانية فعالية هي قاعدة 50/30/20:",
          },
          { type: "bullet", content: "50٪ للاحتياجات: السكن والمرافق والنقل والبقالة والفواتير الأساسية" },
          { type: "bullet", content: "30٪ للرغبات: الترفيه وتناول الطعام في الخارج والتسوق واختيارات نمط الحياة" },
          { type: "bullet", content: "20٪ للادخار: صندوق الطوارئ والاستثمارات والأهداف المستقبلية" },
          {
            type: "none",
            content:
              "بالنسبة للموظفين السعوديين الذين يتقاضون راتباً متوسطاً:",
          },
          { type: "bullet", content: "7,500 ريال للنفقات الأساسية" },
          { type: "bullet", content: "4,500 ريال لإنفاق نمط الحياة" },
          { type: "bullet", content: "3,000 ريال للادخار والاستثمارات" },
        ],
      },
      {
        id: 3,
        title: "2. بناء صندوق الطوارئ",
        description: [
          {
            type: "none",
            content:
              "يوصي الخبراء الماليون بتوفير نفقات 3-6 أشهر في حساب يسهل الوصول إليه. في السياق السعودي، استهدف ما لا يقل عن 30,000 ريال كصندوق طوارئ ابتدائي.",
          },
          { type: "bold", content: "كيفية بناء صندوق الطوارئ:" },
          { type: "bullet", content: "ابدأ بـ 500 ريال شهرياً" },
          { type: "bullet", content: "قم بأتمتة التحويلات إلى حساب توفير منفصل" },
          { type: "bullet", content: "زد المساهمات عند استلام المكافآت" },
          { type: "bullet", content: "فكر في حسابات التوفير ذات العائد المرتفع في البنوك السعودية" },
        ],
      },
      {
        id: 4,
        title: "3. فهم مكافأة نهاية الخدمة",
        description: [
          {
            type: "none",
            content:
              "يحق للموظفين بموجب نظام العمل السعودي الحصول على مكافأة نهاية الخدمة:",
          },
          { type: "bullet", content: "سنتان أو أكثر: نصف راتب شهري عن كل سنة من السنوات الخمس الأولى" },
          { type: "bullet", content: "5 سنوات أو أكثر: راتب شهري كامل عن كل سنة لاحقة" },
          { type: "bullet", content: "استخدم هذا كجزء من تخطيطك المالي طويل المدى" },
        ],
      },
      {
        id: 5,
        title: "4. التخطيط للنفقات الموسمية",
        description: [
          { type: "none", content: "تتميز المملكة العربية السعودية بأنماط إنفاق موسمية فريدة:" },
          { type: "bold", content: "نفقات رمضان" },
          { type: "bullet", content: "زيادة تكاليف الطعام للإفطار والسحور" },
          { type: "bullet", content: "العطاء الخيري (الزكاة والصدقة)" },
          { type: "bullet", content: "التجمعات العائلية والضيافة" },
          { type: "bold", content: "احتفالات العيد" },
          { type: "bullet", content: "الملابس الجديدة لأفراد الأسرة" },
          { type: "bullet", content: "الهدايا والعيدية للأطفال" },
          { type: "bullet", content: "السفر لزيارة الأسرة" },
          {
            type: "none",
            content:
              "نصيحة: ابدأ بالادخار لهذه النفقات قبل 3-4 أشهر بتخصيص 1,000-2,000 ريال شهرياً.",
          },
        ],
      },
      {
        id: 6,
        title: "5. استفد من مزايا صاحب العمل",
        description: [
          { type: "none", content: "يقدم العديد من أصحاب العمل السعوديين مزايا تتجاوز الراتب:" },
          { type: "bullet", content: "بدل السكن: غالباً 25٪ من الراتب الأساسي" },
          { type: "bullet", content: "بدل النقل: 1,000-3,000 ريال شهرياً" },
          { type: "bullet", content: "التأمين الطبي: تغطية الأسرة" },
          { type: "bullet", content: "تذاكر السفر السنوية: للموظفين الوافدين" },
          { type: "bullet", content: "برامج الرفاهية المالية: مثل الوصول المبكر للراتب" },
          {
            type: "none",
            content:
              "تأكد من استخدام جميع المزايا المتاحة لتعظيم إجمالي تعويضاتك.",
          },
        ],
      },
      {
        id: 7,
        title: "6. تجنب الديون ذات الفائدة العالية",
        description: [
          {
            type: "none",
            content:
              "يمكن أن تحمل ديون بطاقات الائتمان في السعودية معدلات فائدة تتراوح بين 20-30٪ سنوياً. لتجنب فخ الديون:",
          },
          { type: "bullet", content: "سدد أرصدة بطاقات الائتمان بالكامل كل شهر" },
          { type: "bullet", content: "استخدم بطاقات الخصم للمشتريات اليومية" },
          { type: "bullet", content: "فكر في البدائل المتوافقة مع الشريعة للمشتريات الكبيرة" },
          { type: "bullet", content: "إذا كنت بحاجة إلى أموال طارئة، استكشف خيارات الوصول المبكر للراتب" },
        ],
      },
      {
        id: 8,
        title: "7. استثمر في مستقبلك",
        description: [
          { type: "none", content: "تقدم المملكة العربية السعودية عدة خيارات استثمارية:" },
          { type: "bold", content: "سوق الأسهم (تداول)" },
          { type: "bullet", content: "افتح حساب تداول مع وسطاء مرخصين" },
          { type: "bullet", content: "ابدأ بالشركات السعودية الكبرى" },
          { type: "bullet", content: "فكر في صناديق المؤشرات للتنويع" },
          { type: "bold", content: "العقارات" },
          { type: "bullet", content: "برامج حكومية مثل سكني للمشترين لأول مرة" },
          { type: "bullet", content: "صناديق الاستثمار العقاري (ريت)" },
          { type: "bold", content: "التخطيط للتقاعد" },
          { type: "bullet", content: "ساهم في خطط التقاعد الطوعية" },
          { type: "bullet", content: "فكر في خطط ادخار التقاعد الخاصة" },
        ],
      },
      {
        id: 9,
        title: "8. تتبع إنفاقك",
        description: [
          { type: "none", content: "استخدم تطبيقات الميزانية لمراقبة أين تذهب أموالك:" },
          { type: "bullet", content: "صنف النفقات تلقائياً" },
          { type: "bullet", content: "حدد حدود الإنفاق لكل فئة" },
          { type: "bullet", content: "راجع أسبوعياً للبقاء على المسار" },
          { type: "bullet", content: "حدد مجالات التوفير المحتملة" },
        ],
      },
      {
        id: 10,
        title: "9. تفاوض على راتبك بحكمة",
        description: [
          { type: "none", content: "سوق العمل السعودي تنافسي. لتعظيم إمكاناتك في الكسب:" },
          { type: "bullet", content: "ابحث عن معدلات السوق لوظيفتك" },
          { type: "bullet", content: "وثق إنجازاتك وتأثيرك" },
          { type: "bullet", content: "وقّت المفاوضات خلال مراجعات الأداء" },
          { type: "bullet", content: "فكر في الحزمة الإجمالية، وليس الراتب الأساسي فقط" },
        ],
      },
      {
        id: 11,
        title: "10. اسعَ للتثقيف المالي",
        description: [
          { type: "none", content: "يمكن للتعلم المستمر عن التمويل الشخصي أن يحول مستقبلك المالي:" },
          { type: "bullet", content: "تابع مبادرات الثقافة المالية من ساما" },
          { type: "bullet", content: "احضر ورش عمل الرفاهية المالية" },
          { type: "bullet", content: "اقرأ الموارد المالية بالعربية والإنجليزية" },
          { type: "bullet", content: "انضم إلى المجتمعات الإلكترونية المتخصصة في التمويل الشخصي في السعودية" },
        ],
      },
      {
        id: 12,
        title: "السيطرة على مستقبلك المالي",
        description: [
          {
            type: "none",
            content:
              "الرفاهية المالية رحلة وليست وجهة. من خلال تطبيق هذه الاستراتيجيات باستمرار، يمكنك تقليل الضغط المالي وبناء الثروة والتمتع براحة بال أكبر. تذكر أن الخطوات الصغيرة المتخذة اليوم تؤدي إلى تحسينات مالية كبيرة بمرور الوقت.",
          },
          {
            type: "none",
            content:
              "ابدأ بنصيحة أو نصيحتين تتناسبان مع وضعك الحالي، وأتقنها، ثم أدمج المزيد من الاستراتيجيات تدريجياً في روتينك المالي.",
          },
        ],
      }
    ],
    articleCopyright: "© 2026 NowPay. جميع الحقوق محفوظة.",
    articalModalTitle: "أكمل القراءة",
    articalModalDescription: "أدخل بياناتك للوصول إلى المقال الكامل",
    articalButton: "فتح المقال",
    arabic: "العربية",
    english: "English",
    formConsent: "أُقرّ بأنني قرأت وفهمت نموذج الموافقة على الخدمة، وأوافق على جمع بياناتي الشخصية واستخدامها والإفصاح عنها وفقًا لما هو موضح فيه.",
  },
};

export function getTranslation(lang: Language) {
  return translations[lang];
}

